import React, { useState, useEffect, useCallback, use } from "react";
import { useSelector, useDispatch } from "react-redux";
import { FormElement, FieldWrapper, Field } from "@progress/kendo-react-form";
import { Label, Error } from "@progress/kendo-react-labels";
import { TextArea } from "@progress/kendo-react-inputs";
import { DateTimePicker } from "@progress/kendo-react-dateinputs";
import { SchedulerFormEditor } from "@progress/kendo-react-scheduler";
import DocumentIcon from "@material-ui/icons/Description";
import "@progress/kendo-date-math/tz/all";

import FormDataEntry from "../../pages/home/admin/FormDataEntry";
import {
  TitleEditor,
  TitleLabel,
  CustomEndEditor,
  StartTimezoneCheckedLabel,
  StartTimezoneCheckedEditor,
  DescriptionLabel,
  DescriptionEditor,
  ClientEditor,
  BookingLocationEditor,
  SessionTypeEditor,
  StatusEditor,
  BookingTypeEditor,
  EventTypeEditor,
  PaymentTypeEditor,
} from "./editors";
import { TextField, MenuItem, Grid, Select, Checkbox, makeStyles, Typography, List, ListItem, ListItemIcon, ListItemText } from "@material-ui/core";
import { Button, Modal, Form, Row, Col, Tabs, Tab } from "react-bootstrap";
import SearchIcon from "@material-ui/icons/Search";
import Autocomplete from "@material-ui/lab/Autocomplete";
import * as Admin from "../../store/ducks/admin.duck";
import PlacesAutoComplete from "../AddressAutoComplete";
import { format } from "date-fns";
import Notes from "../Notes";
import Files from "../Files";
import ClientScores from "../ClientScores";
import BookingBillingList from "../BookingBillingList";
import ReferralMaintenance from "../ReferralMaintenance";

const useStyles = makeStyles((theme) => ({
  noBorder: {
    border: "none",
  },
  formControl: {
    margin: 0, //theme.spacing(1),
    minWidth: 120,
  },
  formControlWide: {
    margin: 0, //theme.spacing(1),
    minWidth: "100%",
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  label: {
    backgroundColor: "#fff",
    paddingLeft: 3,
    paddingRight: 3,
  },
}));

export const CustomFormEditor = (props) => {
  const { psychologistId } = props;
  const dispatch = useDispatch();
  const classes = useStyles();

  const registeredPsychologists = useSelector((state) => state.admin.RegisteredPsychologists);

  const registered =
    (psychologistId && registeredPsychologists && registeredPsychologists?.find((p) => p.id === psychologistId)) || registeredPsychologists?.[0];

  const providerType = registered?.providertype;
  const medicalPractitioners = useSelector((state) => state.admin.MedicalPractitioners);
  const medicalPractices = useSelector((state) => state.admin.MedicalPractices.GeneralPractitioner);
  const timeZone = useSelector((state) => state.reference.TimeZone);
  const areasOfInterestReference = useSelector((state) => state.reference.AreasOfInterest);
  const areasOfInterest = areasOfInterestReference.filter((area) => area.providertype === providerType);
  const client = useSelector((state) => state.admin.Client);
  const role = useSelector((state) => state.auth.roleDesc);
  const providerTemplates = useSelector((state) => state.admin.ProviderTemplates);

  useEffect(() => {
    props.valueGetter("clientID") &&
      dispatch(
        Admin.actions.fetchClient({
          clientID: props.valueGetter("clientID"),
          type: props.valueGetter("clienttype"),
        }),
      );
  }, [dispatch, props]);

  useEffect(() => {
    dispatch(Admin.actions.fetchCsAgents());
  }, [dispatch]);
  const csAgents = useSelector((state) => state.admin.CsAgents);

  useEffect(() => {
    dispatch(Admin.actions.fetchCsCentres());
  }, [dispatch]);
  const csCentres = useSelector((state) => state.admin.CsCentres);

  useEffect(() => {
    dispatch(Admin.actions.fetchPrograms());
  }, [dispatch]);

  useEffect(() => {
    dispatch(Admin.actions.fetchProviderTemplates());
  }, [dispatch]);

  const programs = useSelector((state) => state.admin.Programs);

  var [currentNoteViewType, setcurrentNoteViewType] = useState("NoteOnly");
  var [currentClientID, setcurrentClientID] = useState();
  var [currentMedicalPractitionerID, setcurrentMedicalPractitionerID] = useState();
  var [currentPaymentType, setcurrentPaymentType] = useState();
  var [currentClientBookingType, setcurrentClientBookingType] = useState();
  var [currentTimeZone, setcurrentTimeZone] = useState();
  var [currentfulladdress, setcurrentfulladdress] = useState();
  var [currentLatitude, setcurrentLatitude] = useState();
  var [currentLongitude, setcurrentLongitude] = useState();
  var [currentID, setcurrentID] = useState();
  var [currentPostCode, setcurrentPostCode] = useState();
  var [currentStatus, setcurrentStatus] = useState();
  var [currentPreviousStatus, setcurrentPreviousStatus] = useState();
  var [currentFirstName, setcurrentFirstName] = useState();
  var [currentPreferredName, setcurrentPreferredName] = useState();
  var [currentSurname, setcurrentSurname] = useState();
  var [currentDOB, setcurrentDOB] = useState();
  var [currentEmail, setcurrentEmail] = useState();
  var [currentGender, setcurrentGender] = useState();
  var [currentOccupation, setcurrentOccupation] = useState();
  var [currentMobile, setcurrentMobile] = useState();
  var [currentNote, setcurrentNote] = useState();
  var [currentHopeToGetFromTreatment, setcurrentHopeToGetFromTreatment] = useState();
  var [currentEmergencyContactName1, setcurrentEmergencyContactName1] = useState();
  var [currentEmergencyContactPhone1, setcurrentEmergencyContactPhone1] = useState();
  var [currentEmergencyContactRelation1, setcurrentEmergencyContactRelation1] = useState();
  var [currentEmergencyContactName2, setcurrentEmergencyContactName2] = useState();
  var [currentEmergencyContactPhone2, setcurrentEmergencyContactPhone2] = useState();
  var [currentEmergencyContactRelation2, setcurrentEmergencyContactRelation2] = useState();
  var [currentAreasOfInterest, setcurrentAreasOfInterest] = useState();
  var [currentClientProgram, setcurrentClientProgram] = useState();
  var [currentmedicareno, setcurrentmedicareno] = useState();
  var [currentmedicarereferenceno, setcurrentmedicarereferenceno] = useState();
  var [currentmedicareexpirydate, setcurrentmedicareexpirydate] = useState();
  var [currentAppointmentType, setcurrentAppointmentType] = useState("0");
  var [currentProviderType, setcurrentProviderType] = useState();
  var [currentBusinessName, setcurrentBusinessName] = useState();
  var [currentABN, setcurrentABN] = useState();
  var [currentBusinessAddress, setcurrentBusinessAddress] = useState();
  var [currentBackgroundInformation, setcurrentBackgroundInformation] = useState();
  var [currentHealthCareCard, setcurrentHealthCareCard] = useState();
  var [currentUnemployed, setcurrentUnemployed] = useState();
  var [currentGPMentalHealthPlan12Months, setcurrentGPMentalHealthPlan12Months] = useState();
  var [currentNaturalDisaster, setcurrentNaturalDisaster] = useState();
  var [currentBulkBilledReason, setcurrentBulkBilledReason] = useState();
  const [currentGPName, setcurrentGPName] = useState();
  const [currentGPClinicName, setcurrentGPClinicName] = useState();
  const [currentGPContactNumber, setcurrentGPContactNumber] = useState();
  const [currentNDISNumber, setcurrentNDISNumber] = useState();
  const [currentNDISDateFrom, setcurrentNDISDateFrom] = useState();
  const [currentNDISDateTo, setcurrentNDISDateTo] = useState();
  const [currentNDISPlanManagementProvider, setcurrentNDISPlanManagementProvider] = useState();
  const [currentNDISDiagnosisHistory, setcurrentNDISDiagnosisHistory] = useState();
  const [currentNDISSupportCoordinator, setcurrentNDISSupportCoordinator] = useState();
  const [currentNDISSupportCoordinatorPhone, setcurrentNDISSupportCoordinatorPhone] = useState();
  const [currentNDISActualProviderFee, setcurrentNDISActualProviderFee] = useState();
  const [currentNDISBookingFee, setcurrentNDISBookingFee] = useState();
  const [currentNDISEmailForInvoices, setcurrentNDISEmailForInvoices] = useState();
  const [currentRHCNDISItemCode, setcurrentRHCNDISItemCode] = useState();
  const [currentNDISBillingNote, setcurrentNDISBillingNote] = useState();
  const [currentReferralGPPracticeFax, setcurrentReferralGPPracticeFax] = useState();
  const [currentConsentToShareWithGP, setcurrentConsentToShareWithGP] = useState();
  const [currentPronouns, setcurrentPronouns] = useState();
  const [currentHandOverNotes, setcurrentHandOverNotes] = useState();
  const [currentReferringGPName, setcurrentReferringGPName] = useState();
  const [currentReferringGPProviderNo, setcurrentReferringGPProviderNo] = useState();
  const [currentReferredGPOn, setcurrentReferredGPOn] = useState();
  const [currentAction, setcurrentAction] = useState("None");
  const [currentIndigenous, setcurrentIndigenous] = useState();
  const [currentProgramPopulation, setcurrentProgramPopulation] = useState([]);
  const [currentProgram, setcurrentProgram] = useState(false);
  const [currentContractProviderFee, setcurrentContractProviderFee] = useState();
  const [currentRHCNDISManagedLabel, setcurrentRHCNDISManagedLabel] = useState(false);
  const [currentRHCContractManagedLabel, setcurrentRHCContractManagedLabel] = useState(false);
  const [currentNthQLDPHNBookings, setcurrentNthQLDPHNBookings] = useState();
  const [currentNthQLDPHNPast, setcurrentNthQLDPHNPast] = useState();
  const [currentNthQLDPHNTotal, setcurrentNthQLDPHNTotal] = useState();
  const [currentNthQLDPHNFuture, setcurrentNthQLDPHNFuture] = useState();
  // Centralised Service Fields
  var [currentSpecialistType, setcurrentSpecialistType] = useState();
  var [currentCSCentre, setcurrentCSCentre] = useState();
  var [currentCSCentrePhone, setcurrentCSCentrePhone] = useState();
  var [currentCSCentreName, setcurrentCSCentreName] = useState();
  var [currentMedication, setcurrentMedication] = useState();
  var [currentCentreClientId, setcurrentCentreClientId] = useState();
  var [currentTranslator, setcurrentTranslator] = useState();
  var [currentTranslatorLanguage, setcurrentTranslatorLanguage] = useState();
  var [currentSupportPerson, setcurrentSupportPerson] = useState();
  var [currentSupportPersonDetail, setcurrentSupportPersonDetail] = useState();
  var [currentCsSessionExpect, setcurrentCsSessionExpect] = useState();
  var [currentCsSessionExpectComment, setcurrentCsSessionExpectComment] = useState();
  var [currentEstimatedEndOfCareDate, setcurrentEstimatedEndOfCareDate] = useState();
  var [currentSpecialCircumstances, setcurrentSpecialCircumstances] = useState();
  // Centralised Service Contact
  var [currentOwnerFirstName, setcurrentOwnerFirstName] = useState("");
  var [currentProviderTotal, setcurrentProviderTotal] = useState();
  var [currentOwnerName, setcurrentOwnerName] = useState("");
  var [currentOwnerEmail, setcurrentOwnerEmail] = useState("");
  var [currentOwnerPhone, setcurrentOwnerPhone] = useState("");
  // Centralised Service Additional
  var [currentReferralPurpose, setcurrentReferralPurpose] = useState();
  var [currentReferralInformation, setcurrentReferralInformation] = useState();
  var [currentInitalAssessmentOutcome, setcurrentInitalAssessmentOutcome] = useState();
  var [currentRecentIARFileURL, setcurrentRecentIARFileURL] = useState();
  var [currentIdentifiedRisksAndAgreedManagement, setcurrentIdentifiedRisksAndAgreedManagement] = useState();

  var [show, setShow] = useState(false);
  var [showNotes, setShowNotes] = useState(false);
  var [showFiles, setShowFiles] = useState(false);
  var [showBookingBilling, setShowBookingBilling] = useState(false);
  const [showCancelProviderBooking, setShowCancelProviderBooking] = useState(false);
  const [cancellationReason, setCancellationReason] = useState();
  const [cancellationTypeSMSText, setCancellationTypeSMSText] = useState("");
  const [cancellationType, setCancellationType] = useState("");
  const [cancellationTypeSMS, setCancellationTypeSMS] = useState(false);
  const [booking, setBooking] = useState(false);

  // Diagnostic Report
  const [showDiagnosticForm, setShowDiagnosticForm] = useState(false);
  const [diagnosticReport, setDiagnosticReport] = useState(false);

  var [noteAction, setNoteAction] = useState("SMS");
  var [key, setKey] = React.useState("personalDetails");

  // Define Program Question responses
  const programPopulationOptions = [
    {
      id: "1",
      index: "1",
      name: "Aboriginal and/or Torres Strait Islander",
    },
    {
      id: "2",
      index: "2",
      name: "Culturally and linguistically diverse",
    },
    {
      id: "3",
      index: "3",
      name: "Migrant and Refugee",
    },
    {
      id: "4",
      index: "4",
      name: "Under 20",
    },
    {
      id: "5",
      index: "5",
      name: "Rural and Remote",
    },
  ];

  const initMedicalPractitioner = () => {
    return {
      id: 0,
      providernumber: "",
      salutation: "Dr",
      firstName: "",
      surname: "",
      fullname: "",
      mobilephone: "",
      phone: "",
      type: "Client GP",
    };
  };

  const initMedicalPractice = () => {
    return {
      id: 0,
      abn: "",
      practicename: "",
      phone: "",
      address1: "",
      email: "",
      website: "",
      logoURL: "",
      practiceType: "GeneralPractitioner",
    };
  };

  const initCSCentre = () => {
    return {
      id: 0,
      cSCentreID: "",
      centerName: "",
      email: "",
      phone: "",
      contact: "",
      contactEmail: "",
      contactPhone: "",
    };
  };

  const initProgram = useCallback(() => {
    return {
      id: 0,
      name: "",
      identifier: "",
      description: "",
      status: "Active",
      aoi: 0,
      availabilitytype: "",
      bulkbilling: "N",
    };
  }, []);

  function getIndex(value, arr, prop) {
    for (var i = 0; i < arr.length; i++) {
      if (arr[i][prop] === value) {
        return i;
      }
    }
    return -1; // where the value doesn't exist
  }

  const providerVerbalConsent = (props) => {
    // Close Consent Form and Update Comment to Verbal Consent
    dispatch(
      Admin.actions.putAppointmentConsent({
        id: props.valueGetter("id"),
        refreshPayload: { key: "psychologist", id: registered.id },
      }),
    );
    // Change local state - taking the assumption it works - though it is fairly simple
    props.onChange("bulkBillingFormStatus", {
      value: "Verbal Consent Given",
    });
  };

  const providerResendConsent = (props) => {
    // Resent Consent Form to Client (if new) or if past close new and send past
    dispatch(
      Admin.actions.sendBulkBillingConsentForm({
        id: props.valueGetter("id"),
        days: props.valueGetter("days"),
        refreshPayload: { key: "psychologist", id: registered.id },
      }),
    );
  };

  const handleToggle = (value) => () => {
    const currentIndex = getIndex(value.id, currentProgramPopulation, "id"); //checked.find(r => r.id === value.id);
    const newChecked = [...currentProgramPopulation];
    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }
    setcurrentProgramPopulation(newChecked);
  };

  const loadCSCentre = (thisCSCentre) => {
    setcurrentCSCentre(thisCSCentre ? thisCSCentre : initCSCentre());
    setcurrentCSCentrePhone(thisCSCentre ? thisCSCentre.contactPhone : "");
    setcurrentCSCentreName(thisCSCentre ? thisCSCentre.centerName : "");
  };

  const loadProgram = useCallback(
    (thisProgram) => {
      setcurrentClientProgram(thisProgram ? thisProgram : initProgram());
    },
    [initProgram],
  );

  const getProgramOption = (option, value) => {
    if (option.id === value.id) {
      return option;
    } else {
      return initProgram();
    }
  };

  const loadMedicalPractitioner = (thisMedicalPractitioner) => {
    setcurrentMedicalPractitioner(thisMedicalPractitioner ? thisMedicalPractitioner : initMedicalPractitioner());
    setcurrentMedicalPractitionerID(thisMedicalPractitioner ? thisMedicalPractitioner.id : 0);
    var tempMedicalPractice = thisMedicalPractitioner ? medicalPractices.find((v) => v.id === thisMedicalPractitioner.medicalPracticeID) : null;
    loadMedicalPractitice(tempMedicalPractice);
  };

  const loadMedicalPractitice = (thisMedicalPractice) => {
    setcurrentMedicalPractice(thisMedicalPractice ? thisMedicalPractice : initMedicalPractice());
  };

  function handleAppointmentTypeChange(value) {
    setcurrentAppointmentType(value);
  }

  function updateCancellationTypeSMS(value) {
    setCancellationTypeSMS(value);
  }

  var [currentMedicalPractitioner, setcurrentMedicalPractitioner] = useState(initMedicalPractitioner());
  var [currentMedicalPractice, setcurrentMedicalPractice] = useState(initMedicalPractice());

  const getMedicalPractitionerOption = (option, value) => {
    if (option.id === value.id) {
      return option;
    } else {
      return initMedicalPractitioner();
    }
  };

  const getMedicalPracticeOption = (option, value) => {
    if (option.id === value.id) {
      return option;
    } else {
      return initMedicalPractice();
    }
  };

  function handleTimeZoneAutocompleteChange(propertyName, event, newValue) {
    if (newValue) {
      setcurrentTimeZone(newValue.systemName);
    }
  }

  function cancelBooking(id) {
    // Need to handle no show which is triggered if it is save by a provider and reason is not selected - it is like the multiverse
    if (cancellationType === "NoShow") {
      // Update database as client did not show
      dispatch(
        Admin.actions.putAppointment({
          id: id,
          status: "NoShow",
          cancellationReason: cancellationReason,
          refreshPayload: { key: "psychologist", id: registered.id },
        }),
      );
      // Update local display
      setBooking({ ...booking, status: "NoShow" });
      if (cancellationTypeSMS && cancellationTypeSMSText && cancellationTypeSMSText.length > 10) {
        const formData = new FormData();
        formData.append("type", "Client");
        formData.append("pkid", booking.clientID);
        formData.append("subject", "");
        formData.append("selector", "SMS");
        formData.append("note", cancellationTypeSMSText);
        formData.append("faxdestination", "");
        formData.append("faxFile", "");
        formData.append("sendFormID", 0);
        // Ok Time to Dispatch
        process.env.REACT_APP_DEBUG && console.log(...formData);
        dispatch(
          Admin.actions.postNote({
            formData: formData,
            type: "Client",
            pkID: booking.clientID,
          }),
        );
      }
    } else {
      if (cancellationType === "LateCancel") {
        dispatch(
          Admin.actions.putAppointment({
            id: id,
            status: "LateCancel",
            cancellationReason: cancellationReason,
            refreshPayload: { key: "psychologist", id: registered.id },
          }),
        );
        // Update local display
        setBooking({ ...booking, status: "LateCancel" });
      } else {
        if (cancellationType === "LateCancelProvider") {
          dispatch(
            Admin.actions.putAppointment({
              id: id,
              status: "LateCancelProvider",
              cancellationReason: cancellationReason,
              refreshPayload: { key: props.type, id: props.id },
            }),
          );
          // Update local display
          setBooking({ ...booking, status: "LateCancelProvider" });
        } else {
          // Update database as booking cancelled by provider
          dispatch(
            Admin.actions.putAppointment({
              id: id,
              status: "Cancelled",
              cancellationReason: cancellationReason,
              refreshPayload: { key: "psychologist", id: registered.id },
            }),
          );
          // Update local display
          setBooking({ ...booking, status: "Cancelled" });
        }
      }
    }
    // Close provider booking cancel modal - if open
    setShowCancelProviderBooking(false);
  }

  function putClient() {
    var payload = {
      profileClientID: currentClientID,
      profileFirstName: currentFirstName,
      profilePreferredName: currentPreferredName,
      profileSurname: currentSurname,
      profileDOB: currentDOB,
      profileEmail: currentEmail,
      profileGender: currentGender,
      profileOccupation: currentOccupation,
      profileMobile: currentMobile,
      profilefulladdress: currentfulladdress,
      profileStatus: currentStatus,
      profilepreviousstatus: currentPreviousStatus,
      profileNote: currentNote,
      profilehopeToGetFromTreatment: currentHopeToGetFromTreatment,
      profileMedicalPractitionerID: currentMedicalPractitionerID,
      profilePaymentType: currentPaymentType,
      profileTimeZone: currentTimeZone,
      profileLatitude: currentLatitude,
      profileLongitude: currentLongitude,
      profilePostCode: currentPostCode,
      emergencycontactname1: currentEmergencyContactName1,
      emergencycontactphone1: currentEmergencyContactPhone1,
      emergencycontactrelation1: currentEmergencyContactRelation1,
      emergencycontactname2: currentEmergencyContactName2,
      emergencycontactphone2: currentEmergencyContactPhone2,
      emergencycontactrelation2: currentEmergencyContactRelation2,
      profilemedicareno: currentmedicareno,
      profilemedicarereferenceno: currentmedicarereferenceno,
      profilemedicareexpirydate: currentmedicareexpirydate,
      profileAreasOfInterest: currentAreasOfInterest.map((aoi) => aoi.issue).join(","),
      medicalPractice: currentMedicalPractice,
      medicalPractitioner: currentMedicalPractitioner,
      status: currentStatus,
      appointmenttype: currentAppointmentType,
      profilegpname: currentGPName,
      profilegpclinicname: currentGPClinicName,
      profilendisnumber: currentNDISNumber,
      profilendisdatefrom: currentNDISDateFrom,
      profilendisdateto: currentNDISDateTo,
      profilendisplanmanagementprovider: currentNDISPlanManagementProvider,
      profilendisdiagnosishistory: currentNDISDiagnosisHistory,
      profilendisemailforinvoices: currentNDISEmailForInvoices,
      profilendisbookingfee: currentNDISBookingFee,
      profileRHCNDISItemCode: currentRHCNDISItemCode,
      profileNDISBillingNote: currentNDISBillingNote,
      profilepassword: null,
      profilepasswordconfirmation: null,
      profileConsentToShareWithGP: currentConsentToShareWithGP,
      profilePronouns: currentPronouns,
      profileIndigenous: currentIndigenous,
      profileNDISSupportCoordinator: currentNDISSupportCoordinator,
      profileNDISSupportCoordinatorPhone: currentNDISSupportCoordinatorPhone,
      profileprogrampopulation: currentProgramPopulation.map((pp) => pp.name).join(","),
      profileNthQLDPHNBookings: currentNthQLDPHNBookings,
    };
    //
    if (process.env.REACT_APP_DEBUG) {
      console.log("Putting (Update)");
    }
    // Save update
    dispatch(Admin.actions.putClientDetail(payload));
    // Close form
    setShow(false);
  }

  const loadProfile = useCallback(
    (thisClient) => {
      setcurrentProviderType(providerType);
      setcurrentPaymentType(thisClient.paymentType);
      // Check to see if it supervision client - if so update providertype
      if (thisClient.paymentType === "Supervision") {
        setcurrentProviderType("Supervision");
      }
      //
      setcurrentClientID(thisClient.id);
      setcurrentID(thisClient.id);
      setcurrentMedicalPractitionerID(thisClient.medicalPractitionerID);
      setcurrentPaymentType(thisClient.paymentType);
      setcurrentClientBookingType(thisClient.appointmenttype === "1" ? "PHONE" : "VIDEO");
      setcurrentfulladdress(thisClient.fulladdress);
      setcurrentStatus(thisClient.status);
      setcurrentPreviousStatus(thisClient.status);
      setcurrentLatitude(thisClient.latitude);
      setcurrentLongitude(thisClient.longitude);
      setcurrentFirstName(thisClient.firstname);
      setcurrentPreferredName(thisClient.preferredname);
      setcurrentSurname(thisClient.surname);
      setcurrentDOB(thisClient.dob);
      setcurrentEmail(thisClient.email);
      setcurrentGender(thisClient.gender);
      setcurrentOccupation(thisClient.occupation);
      setcurrentMobile(thisClient.mobilephone);
      setcurrentNote(thisClient.note);
      setcurrentTimeZone(thisClient.timeZone);
      setcurrentPostCode(thisClient.postCode);
      setcurrentHopeToGetFromTreatment(thisClient.hopeToGetFromTreatment);
      setcurrentEmergencyContactName1(thisClient.emergencycontactname1);
      setcurrentEmergencyContactPhone1(thisClient.emergencycontactphone1);
      setcurrentEmergencyContactRelation1(thisClient.emergencycontactrelation1);
      setcurrentEmergencyContactName2(thisClient.emergencycontactname2);
      setcurrentEmergencyContactPhone2(thisClient.emergencycontactphone2);
      setcurrentEmergencyContactRelation2(thisClient.emergencycontactrelation2);
      setcurrentmedicareno(thisClient.medicareno);
      setcurrentmedicarereferenceno(thisClient.medicarereferenceno);
      setcurrentmedicareexpirydate(thisClient.medicareexpirydate);
      setcurrentAppointmentType(thisClient.appointmenttype);
      setcurrentStatus(thisClient.status);
      setcurrentBusinessName(thisClient.businessName);
      setcurrentABN(thisClient.abn);
      setcurrentBusinessAddress(thisClient.businessAddress);
      setcurrentBackgroundInformation(thisClient.backgroundInformation);
      setcurrentHealthCareCard(thisClient.healthcarecard);
      setcurrentUnemployed(thisClient.unemployed);
      setcurrentNaturalDisaster(thisClient.naturaldisaster);
      setcurrentGPMentalHealthPlan12Months(thisClient.gpmentalhealthplan12months);
      setcurrentBulkBilledReason(thisClient.bulkbilledreason);
      setcurrentGPName(thisClient.gpName);
      setcurrentGPClinicName(thisClient.gpClinicName);
      setcurrentNDISNumber(thisClient.ndisnumber);
      setcurrentNDISDateFrom(thisClient.ndisdatefrom);
      setcurrentNDISDateTo(thisClient.ndisdateto);
      setcurrentNDISPlanManagementProvider(thisClient.ndisplanmanagementprovider);
      setcurrentNDISDiagnosisHistory(thisClient.ndisdiagnosishistory);
      setcurrentNDISActualProviderFee(thisClient.ndisactualproviderfee);
      setcurrentReferralGPPracticeFax(thisClient.referralGPPracticeFax);
      setcurrentNDISEmailForInvoices(thisClient.ndisemailforinvoices);
      setcurrentNDISBookingFee(thisClient.ndisbookingfee);
      setcurrentRHCNDISItemCode(thisClient.rhcndisitemcode);
      setcurrentNDISBillingNote(thisClient.ndisbillingnote);
      setcurrentConsentToShareWithGP(thisClient.consentToShareWithGP);
      setcurrentPronouns(thisClient.pronouns);
      setcurrentIndigenous(thisClient.indigenous);
      setcurrentHandOverNotes(thisClient.handOverNotes);
      setcurrentNDISSupportCoordinator(thisClient.ndissupportcoordinator);
      setcurrentNDISSupportCoordinatorPhone(thisClient.ndissupportcoordinatorphone);
      setcurrentReferringGPName(thisClient.referringGPName);
      setcurrentReferringGPProviderNo(thisClient.referringGPProviderNo);
      setcurrentReferredGPOn(thisClient.referredGPOn);
      setcurrentContractProviderFee(thisClient.contractproviderfee);
      setcurrentNthQLDPHNBookings(thisClient.nthQLDPHNEstimated);
      setcurrentNthQLDPHNPast(thisClient.nthQLDPHNPast);
      setcurrentNthQLDPHNTotal(thisClient.nthQLDPHNTotal);
      setcurrentNthQLDPHNFuture(thisClient.nthQLDPHNFuture);
      // Set CS Fields
      setcurrentSupportPerson(thisClient.supportPerson);
      setcurrentSupportPersonDetail(thisClient.supportPersonDetail);
      setcurrentCsSessionExpect(thisClient.csSessionExpect);
      setcurrentCsSessionExpectComment(thisClient.csSessionExpectComment);
      setcurrentSpecialistType(thisClient.specialisttype);
      setcurrentMedication(thisClient.medication);
      setcurrentIdentifiedRisksAndAgreedManagement(thisClient.identifiedRisksAndAgreedManagement);
      setcurrentEstimatedEndOfCareDate(thisClient.estimatedEndOfCareDate);
      setcurrentSpecialCircumstances(thisClient.specialCircumstances);
      // set CS Additional
      setcurrentReferralPurpose(thisClient.referralPurpose);
      setcurrentReferralInformation(thisClient.referralInformation);
      setcurrentInitalAssessmentOutcome(thisClient.initalAssessmentOutcome);
      setcurrentRecentIARFileURL(thisClient.recentIARFileURL);
      // Set Provider Total
      setcurrentProviderTotal(thisClient.providerTotal);

      const owner = csAgents.find((agent) => String(agent.id) === String(thisClient.owner));
      if (owner) {
        setcurrentOwnerFirstName(owner.firstname);
        setcurrentOwnerName(owner.fullname);
        setcurrentOwnerEmail(owner.email);
        setcurrentOwnerPhone(owner.mobilephone);
      }
      setcurrentTranslator(thisClient.translator === "1" ? true : false);
      loadCSCentre(csCentres.find((v) => String(v.id) === String(thisClient.csCentreID)));
      setcurrentCentreClientId(thisClient.centreClientId);
      if (thisClient.rhcndismanagment === "1") {
        setcurrentRHCNDISManagedLabel(true);
      } else {
        setcurrentRHCNDISManagedLabel(false);
      }
      if (thisClient.rhccontractmanagement === "1") {
        setcurrentRHCContractManagedLabel(true);
      } else {
        setcurrentRHCContractManagedLabel(false);
      }
      //
      loadProgram(programs.find((v) => v.id === thisClient.programid));

      var aoi_clienttype = areasOfInterestReference.filter((area) => area.providertype === providerType);
      var aoi = aoi_clienttype.filter(({ issue }) => thisClient.clientAreasOfInterest.includes(issue));
      setcurrentAreasOfInterest(aoi);

      var aoi_program = aoi.filter((aoip) => aoip.program !== null && aoip.program !== 0);
      if (aoi_program && aoi_program.length > 0) {
        setcurrentProgram(true);
      }
      var programPopulation = programPopulationOptions.filter(({ name }) => thisClient.programpopulation.includes(name));
      setcurrentProgramPopulation(programPopulation);

      loadMedicalPractitioner(medicalPractitioners.find((v) => v.id === thisClient.medicalPractitionerID));
      // Load Form
      setShow(true);
    },
    [areasOfInterestReference, loadMedicalPractitioner, medicalPractitioners, providerType, programs, csCentres],
  );

  function loadBooking(props) {
    var bookingData = {
      id: props.valueGetter("id"),
      clientfullname: client.fullname,
      psychologistfullname: registered.fullname,
      psychologistDate: props.valueGetter("start"),
      clientID: client.id,
      paymentType: props.valueGetter("paymentType"),
      bookingType: props.valueGetter("bookingType"),
      sessionType: props.valueGetter("bookingCode"),
      bookingLocation: props.valueGetter("bookingLocation"),
    };
    setCancellationTypeSMSText(
      `Hello ${client && client.preferredname && client.preferredname.length > 0 ? client.preferredname : client.firstname}, We notice you did not attend your appointment with Rural Health Connect. We hope everything is OK. If you would like to discuss or reschedule please call us on 0493201005 or 0493432144 or your provider directly.`,
    );
    setBooking(bookingData);
    // Open Provider Cancel Modal
    setShowCancelProviderBooking(true);
  }

  function loadFiles(thisClient) {
    setcurrentClientID(thisClient.id);
    setcurrentFirstName(thisClient.firstname);
    setcurrentSurname(thisClient.surname);
    setShowFiles(true);
  }

  function loadNoteOnly(thisClient, noteAction) {
    setNoteAction(noteAction);
    setcurrentClientID(thisClient.id);
    setcurrentID(thisClient.id);
    setcurrentFirstName(thisClient.firstname);
    setcurrentPreferredName(thisClient.preferredname);
    setcurrentSurname(thisClient.surname);
    setcurrentReferralGPPracticeFax(thisClient.referralGPPracticeFax);
    setcurrentEmail(thisClient.email);
    setcurrentNoteViewType("NoteOnly");
    setcurrentSpecialistType(thisClient.specialisttype);
    setcurrentMobile(thisClient.mobilephone);
    setShowNotes(true);
  }

  function loadNotes(thisClient, noteAction) {
    setNoteAction(noteAction);
    setcurrentClientID(thisClient.id);
    setcurrentID(thisClient.id);
    setcurrentFirstName(thisClient.firstname);
    setcurrentPreferredName(thisClient.preferredname);
    setcurrentSurname(thisClient.surname);
    setcurrentReferralGPPracticeFax(thisClient.referralGPPracticeFax);
    setcurrentEmail(thisClient.email);
    setcurrentMobile(thisClient.mobilephone);
    setcurrentNoteViewType("CommunicationOnly");
    setShowNotes(true);
  }

  function loadBookingBilling(thisClient, noteAction) {
    setcurrentClientID(thisClient.id);
    setcurrentID(thisClient.id);
    setcurrentFirstName(thisClient.firstname);
    setcurrentSurname(thisClient.surname);
    setcurrentDOB(thisClient.dob);
    setcurrentEmail(thisClient.email);
    setcurrentMobile(thisClient.mobilephone);
    setcurrentmedicareno(thisClient.medicareno);
    setcurrentmedicarereferenceno(thisClient.medicarereferenceno);
    setcurrentmedicareexpirydate(thisClient.medicareexpirydate);
    setcurrentReferringGPName(thisClient.referringGPName);
    setcurrentReferringGPProviderNo(thisClient.referringGPProviderNo);
    setcurrentReferredGPOn(thisClient.referredGPOn);
    setShowBookingBilling(true);
  }

  function loadDiagnosticReport(thisClient, props) {
    var diagnosticReportData = {
      clientfullname: client.fullname,
      psychologistfullname: registered.fullname,
      clientID: client.id,
      bookingType: props.valueGetter("bookingType"),
      sessionType: props.valueGetter("bookingCode"),
    };
    setDiagnosticReport(diagnosticReportData);
    setcurrentID(thisClient.id);
    setcurrentFirstName(thisClient.firstname);
    setcurrentSurname(thisClient.surname);
    // Open Diagnostic Report Form
    setShowDiagnosticForm(true);
  }

  const getCommonAvailabilityProps = (props) => {
    const id = props.valueGetter("id");

    return {
      ...props,
      titleLabel: TitleLabel,
      titleEditor: TitleEditor,
      endEditor: !id ? CustomEndEditor : DateTimePicker,
      startTimezoneCheckedLabel: StartTimezoneCheckedLabel,
      startTimezoneCheckedEditor: StartTimezoneCheckedEditor,
      descriptionLabel: DescriptionLabel,
      descriptionEditor: DescriptionEditor,
      horizontal: true,
    };
  };

  const isAvailability = props.valueGetter("eventType")?.startsWith("availability");

  if (isAvailability) {
    document.body.setAttribute("data-event-type", "availability");
  } else {
    document.body.removeAttribute("data-event-type");
  }

  if (isAvailability) {
    return (
      <div className={isAvailability ? "modal-availability" : ""}>
        <SchedulerFormEditor {...getCommonAvailabilityProps(props)} />
      </div>
    );
  }

  const renderBookingForm = (props) => {
    return (
      <FormElement horizontal={true} style={{ height: role !== "Admin" ? (!props.valueGetter("id") ? 460 : 560) : 460 }}>
        {!props.valueGetter("id") && (
          <FieldWrapper style={{ display: "flex" }}>
            <Label>Type</Label>
            <div className={"k-form-field-wrap"} style={{ width: 120 }}>
              <Field
                label="Type"
                name={"eventType"}
                component={EventTypeEditor}
                eapcontractndis={(registered && registered.eapContractNDISAvailability === "Y") || role === "Admin" ? true : false}
                // eapAvailability={(registered && registered.eapAvailability === "Y") || role === "Admin" ? true : false} - EAP only availability is being retired
                nthqldphn={(registered && registered.specialisttype === "nthqldphn") || role === "Admin" ? true : false}
                centralisedservice={(registered && registered.specialisttype === "centralisedservice") || role === "Admin" ? true : false}
                centralisedservicePsychiatrist={(registered && registered.providertype === "Psychiatrist") || role === "Admin" ? true : false}
                admin={role === "Admin" ? true : false}
              />
              {props.visited && props.errors.eventType && <Error>{props.errors.eventType}</Error>}
            </div>
          </FieldWrapper>
        )}
        <FieldWrapper style={{ display: "flex" }}>
          <Label>Start</Label>
          <div className="k-form-field-wrap">
            <Field name={"start"} component={DateTimePicker} rows={1} width={"200px"} format="dd/MM/yyyy hh:mm a" steps={{ minute: 15 }} />
          </div>
        </FieldWrapper>
        <FieldWrapper style={{ display: "flex" }}>
          <Label>End</Label>
          <div className="k-form-field-wrap">
            <Field
              name={"end"}
              component={!props.valueGetter("id") ? CustomEndEditor : DateTimePicker}
              as={DateTimePicker}
              eventType={props.valueGetter("eventType")}
              bookingCode={props.valueGetter("bookingCode")}
              start={props.valueGetter("start")}
              width={"200px"}
              rows={1}
              format="dd/MM/yyyy hh:mm a"
              steps={{ minute: 15 }}
            />{" "}
          </div>
        </FieldWrapper>
        <FieldWrapper style={{ display: "flex" }}>
          <Label>Client</Label>
          <div className="k-form-field-wrap">
            <Field name={"clientID"} component={ClientEditor} disabled={props.valueGetter("id")} />
            {props.visited && props.errors.clientID && <Error>{props.errors.clientID}</Error>}
          </div>
        </FieldWrapper>
        {props.valueGetter("id") && (
          <FieldWrapper>
            <Label>Payment</Label>

            <div className="k-form-field-wrap">
              <Field name="paymentType" component={PaymentTypeEditor} client={client} />
              {props.visited && props.errors.paymentType && <Error>{props.errors.paymentType}</Error>}
            </div>
            {props.valueGetter("status") === "Active" &&
              registered &&
              registered.autoBulkBillingConsentForm === "Y" &&
              props.valueGetter("clientID") > 0 &&
              client.id > 0 &&
              client.specialisttype !== "centralisedservice" &&
              props.valueGetter("paymentType") === "Bulk Billed" &&
              props.valueGetter("bulkBillingFormStatus") !== "Completed" &&
              props.valueGetter("bulkBillingFormStatus") !== "Verbal Consent Given" &&
              props.valueGetter("id") > 0 && (
                <div
                  style={{
                    display: "flex",
                    gap: "20px",
                    transform: "translateX(-60px)",
                    alignItems: "center",
                  }}
                >
                  <Button
                    variant="success"
                    size="sm"
                    style={{
                      whiteSpace: "nowrap",
                      fontWeight: 600,
                      padding: "0.55rem 1rem",
                    }}
                    onClick={() => providerVerbalConsent(props)}
                  >
                    Verbal Consent
                  </Button>

                  <Button
                    variant="warning"
                    size="sm"
                    style={{
                      whiteSpace: "nowrap",
                      fontWeight: 600,
                      color: "#212529",
                      padding: "0.55rem 1rem",
                    }}
                    onClick={() => providerResendConsent(props)}
                  >
                    Resend Consent
                  </Button>
                </div>
              )}
          </FieldWrapper>
        )}
        <FieldWrapper style={{ display: "flex" }}>
          <Label>Note</Label>
          <div className="k-form-field-wrap">
            <Field name={"note"} component={TextArea} rows={2} />
          </div>
        </FieldWrapper>

        <FieldWrapper style={{ display: "flex" }}>
          <Label>Booking Type</Label>
          <div className="k-form-field-wrap">
            <Field
              name={"bookingType"}
              component={BookingTypeEditor}
              client={client}
              nthqldphn={
                registered &&
                registered.specialisttype === "nthqldphn" &&
                registered.facetoFaceBooking === "Y" &&
                client &&
                client.specialisttype === "nthqldphn"
                  ? true
                  : false
              }
            />
            {props.visited && props.errors.bookingType && <Error>{props.errors.bookingType}</Error>}
          </div>
        </FieldWrapper>

        {(props.valueGetter("status") === "Active" || props.valueGetter("status") === "Attended") &&
        props.valueGetter("clientID") > 0 &&
        client.id > 0 &&
        client.specialisttype === "centralisedservice" ? (
          <FieldWrapper style={{ display: "flex" }}>
            <Label>Session Type</Label>
            <div className="k-form-field-wrap">
              <Field name={"bookingCode"} component={SessionTypeEditor} providerType={registered && registered.providertype} />
            </div>
          </FieldWrapper>
        ) : null}
        {(props.valueGetter("status") === "Active" || props.valueGetter("status") === "Attended") &&
        props.valueGetter("clientID") > 0 &&
        client.id > 0 &&
        client.specialisttype === "centralisedservice" ? (
          <FieldWrapper style={{ display: "flex" }}>
            <Label>Location</Label>
            <div className="k-form-field-wrap" style={{ maxWidth: 120 }}>
              <Field name={"bookingLocation"} component={BookingLocationEditor} providerType={registered && registered.providertype} />
            </div>

            {props.valueGetter("bookingCode") === "P0101" || props.valueGetter("bookingCode") === "P0201" ? (
              <div className="k-form-field-wrap" style={{ maxWidth: 420 }}>
                <a
                  href={`https://files.ruralhealthconnect.com.au/fileStoreRHC/${providerTemplates.csAssessmentReportTemplateURL}`}
                  download
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    color: "#1976d2", // standard link blue (MUI-ish)
                    textDecoration: "underline",
                    fontWeight: 400,
                    marginLeft: 30,
                    marginTop: 5,
                  }}
                >
                  <DocumentIcon style={{ marginRight: 6, fontSize: 18 }} />
                  Diagnostic Assessment Report Template
                </a>
              </div>
            ) : null}
            {props.valueGetter("bookingCode") === "P0102" || props.valueGetter("bookingCode") === "P0202" ? (
              <div className="k-form-field-wrap" style={{ maxWidth: 420 }}>
                <a
                  href={`https://files.ruralhealthconnect.com.au/fileStoreRHC/${providerTemplates.csDischargeSummaryReportTemplateURL}`}
                  download
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    color: "#1976d2", // standard link blue (MUI-ish)
                    textDecoration: "underline",
                    fontWeight: 400,
                    marginLeft: 30,
                    marginTop: 5,
                  }}
                >
                  <DocumentIcon style={{ marginRight: 6, fontSize: 18 }} />
                  Discharge Summary Report Template
                </a>
              </div>
            ) : null}
          </FieldWrapper>
        ) : null}

        <FieldWrapper style={{ display: "flex" }}>
          <Label>Status</Label>
          <div className="k-form-field-wrap" style={{ maxWidth: 190 }}>
            <Field name={"status"} component={StatusEditor} />
          </div>
          {(props.valueGetter("status") === "Active" || props.valueGetter("status") === "Attended") &&
          props.valueGetter("clientID") > 0 &&
          client.id > 0 &&
          client.specialisttype !== "centralisedservice" &&
          props.valueGetter("id") > 0 ? (
            <div className="k-form-field-wrap" style={{ maxWidth: 220 }}>
              <Button
                variant="secondary"
                size="sm"
                style={{
                  color: "black",
                  fontWeight: 500,
                  border: "1px solid rgb(192 192 192)",
                  background: "#faa0a0",
                  marginLeft: 30,
                  marginRight: 10,
                }}
                onClick={() => loadBooking(props)}
              >
                Cancel Booking
              </Button>
            </div>
          ) : null}
        </FieldWrapper>
        {props.valueGetter("clientID") > 0 && client.id > 0 && role !== "Admin" ? (
          <FieldWrapper style={{ display: "flex" }}>
            <Label>Actions</Label>
            <Button
              variant="secondary"
              size="sm"
              style={{
                color: "black",
                fontWeight: 500,
                border: "1px solid rgb(192 192 192)",
                background: "#b2b6eb",
                marginRight: 10,
              }}
              onClick={() => loadProfile(client)}
            >
              Profile
            </Button>
            <Button
              variant="secondary"
              size="sm"
              style={{
                color: "black",
                fontWeight: 500,
                border: "1px solid rgb(192 192 192)",
                background: "#ede9fe",
                marginRight: 10,
              }}
              onClick={() => loadNoteOnly(client, "Note")}
            >
              Notes
            </Button>

            <Button
              variant="secondary"
              size="sm"
              style={{
                color: "black",
                fontWeight: 500,
                border: "1px solid rgb(192 192 192)",
                background: "#faefcf",
                marginRight: 10,
              }}
              onClick={() => loadNotes(client, "SMS")}
            >
              SMS
            </Button>
            <Button
              variant="secondary"
              size="sm"
              style={{
                color: "black",
                fontWeight: 500,
                border: "1px solid rgb(192 192 192)",
                background: "#d2f9fa",
                marginRight: 10,
              }}
              onClick={() => loadNotes(client, "Email")}
            >
              Email
            </Button>
            <Button
              variant="secondary"
              size="sm"
              style={{
                color: "black",
                fontWeight: 500,
                border: "1px solid rgb(192 192 192)",
                background: "#ebfae8",
                marginRight: 10,
              }}
              onClick={() => loadFiles(client)}
            >
              Files
            </Button>
            <Button
              variant="secondary"
              size="sm"
              style={{
                color: "black",
                fontWeight: 500,
                border: "1px solid rgb(192 192 192)",
                background: "#fff0ed",
                marginRight: 10,
              }}
              onClick={() => loadNotes(client, "Fax")}
            >
              Fax
            </Button>
            <Button
              variant="secondary"
              size="sm"
              style={{
                color: "black",
                fontWeight: 500,
                border: "1px solid rgb(192 192 192)",
                background: "#fffbc2",
                marginRight: 10,
              }}
              onClick={() => loadNotes(client, "Form")}
            >
              Forms
            </Button>
            <Button
              variant="secondary"
              size="sm"
              style={{
                color: "black",
                fontWeight: 500,
                border: "1px solid rgb(192 192 192)",
                background: "#FF9636",
                marginRight: 10,
              }}
              onClick={() => loadBookingBilling(client)}
            >
              Billing
            </Button>
          </FieldWrapper>
        ) : (
          <FieldWrapper style={{ display: "flex" }}></FieldWrapper>
        )}

        <Modal show={showNotes} onHide={() => setShowNotes(false)} dialogClassName="notes-modal-dialog" style={{ zIndex: 1150 }}>
          <Modal.Header closeButton className="notes-modal">
            <Modal.Title>
              {currentNoteViewType === "CommunicationOnly" ? "Communications" : "Notes"} - {currentFirstName} {currentSurname}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="notes-modal">
            {registered ? (
              <Notes
                type="Client"
                ownerName={currentOwnerFirstName}
                specialistType={currentSpecialistType}
                noteAction={noteAction}
                pkid={currentClientID}
                firstName={currentPreferredName && currentPreferredName.length > 2 ? currentPreferredName : currentFirstName}
                faxGP={currentReferralGPPracticeFax}
                medicalPractice={currentMedicalPractice}
                waitingRoomURL={registered && (registered.teleHealthProvider === "COVIU" ? registered.coviuRoomURL : registered.waitingRoomURL)}
                psychologistFullName={registered.firstname + " " + registered.surname}
                clientFirstName={currentFirstName}
                email={currentEmail}
                mobilephone={currentMobile}
                providerTotal={currentProviderTotal}
                viewType={currentNoteViewType}
              />
            ) : null}
          </Modal.Body>
          <Modal.Footer className="notes-modal">
            <Button variant="secondary" onClick={() => setShowNotes(false)}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal show={showFiles} onHide={() => setShowFiles(false)} dialogClassName="notes-modal-dialog" style={{ zIndex: 1150 }}>
          <Modal.Header closeButton className="notes-modal">
            <Modal.Title>
              Files - {currentFirstName} {currentSurname}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="notes-modal">
            {registered ? <Files type="Client" pkid={currentClientID} specialistType={currentSpecialistType} /> : null}
          </Modal.Body>
          <Modal.Footer className="notes-modal">
            <Button variant="secondary" onClick={() => setShowFiles(false)}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal show={showBookingBilling} onHide={() => setShowBookingBilling(false)} dialogClassName="notes-modal-dialog" style={{ zIndex: 1150 }}>
          <Modal.Header closeButton className="notes-modal">
            <Modal.Title>
              Billing - {currentFirstName} {currentSurname}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="notes-modal">
            {registered ? (
              <BookingBillingList
                id={currentClientID}
                clientFirstName={currentFirstName}
                clientSurname={currentSurname}
                clientDOB={currentDOB}
                clientEmail={currentEmail}
                clientMobile={currentMobile}
                clientMedicareNo={currentmedicareno}
                clientMedicareReferenceNo={currentmedicarereferenceno}
                clientMedicareExpiryDate={currentmedicareexpirydate}
                clientreferringGPName={currentReferringGPName}
                clientreferringGPProviderNo={currentReferringGPProviderNo}
                clientreferredOn={currentReferredGPOn}
              />
            ) : null}
          </Modal.Body>
          <Modal.Footer className="notes-modal">
            <Button variant="secondary" onClick={() => setShowBookingBilling(false)}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal show={show} onHide={() => setShow(false)} dialogClassName="editprofile-modal" style={{ zIndex: 1150 }}>
          <Modal.Header closeButton className="editprofile-modal">
            <Modal.Title>
              Edit Profile - {currentFirstName} {currentSurname}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="editprofile-modal">
            <Form onSubmit={putClient}>
              <Tabs id="EditModal" activeKey={key} onSelect={(k) => setKey(k)}>
                <Tab eventKey="personalDetails" title="Personal" style={{ backgroundColor: "rgb(245, 245, 245)", padding: 6 }}>
                  {currentSpecialistType === "centralisedservice" ? (
                    <>
                      <Row>
                        <Col md="6">
                          <Form.Group style={{ width: "100%" }}>
                            <Form.Label>Centre contact</Form.Label>
                            <Form.Control type="text" name="ownerName" value={currentOwnerName} readOnly style={{ backgroundColor: "#e9ecef" }} />
                          </Form.Group>
                        </Col>
                        <Col md="3">
                          <Form.Group style={{ width: "100%" }}>
                            <Form.Label>Contact Email</Form.Label>
                            <Form.Control type="text" name="ownerEmail" value={currentOwnerEmail} readOnly style={{ backgroundColor: "#e9ecef" }} />
                          </Form.Group>
                        </Col>
                        <Col md="3">
                          <Form.Group style={{ width: "100%" }}>
                            <Form.Label>Contact Phone</Form.Label>
                            <Form.Control type="text" name="ownerPhone" value={currentOwnerPhone} readOnly style={{ backgroundColor: "#e9ecef" }} />
                          </Form.Group>
                        </Col>
                      </Row>
                      <Row>
                        <Col md="6">
                          <Form.Group style={{ width: "100%" }}>
                            <Form.Label>Centre</Form.Label>
                            <Form.Control type="text" name="currentCSCentreName" value={currentCSCentreName} readOnly style={{ backgroundColor: "#e9ecef" }} />
                          </Form.Group>
                        </Col>
                        <Col md="3">
                          <Form.Group style={{ width: "100%" }}>
                            <Form.Label>Centre Phone</Form.Label>
                            <Form.Control
                              type="text"
                              name="currentCSCentrePhone"
                              value={currentCSCentrePhone}
                              readOnly
                              style={{ backgroundColor: "#e9ecef" }}
                            />
                          </Form.Group>
                        </Col>
                      </Row>

                      <hr />
                    </>
                  ) : null}
                  <Row>
                    <Col md="3">
                      <Form.Group>
                        <Form.Label>First Name</Form.Label>
                        <Form.Control
                          type="text"
                          name="profileFirstName"
                          defaultValue={currentFirstName}
                          onBlur={(event) => setcurrentFirstName(event.target.value)}
                          autoComplete="new-password"
                        />
                      </Form.Group>
                    </Col>
                    <Col md="3">
                      <Form.Group>
                        <Form.Label>Preferred Name</Form.Label>
                        <Form.Control
                          type="text"
                          name="profilePreferredName"
                          defaultValue={currentPreferredName}
                          onBlur={(event) => setcurrentPreferredName(event.target.value)}
                          autoComplete="new-password"
                        />
                      </Form.Group>
                    </Col>
                    <Col md="3">
                      <Form.Group>
                        <Form.Label>Surname</Form.Label>
                        <Form.Control
                          type="text"
                          name="profileSurname"
                          defaultValue={currentSurname}
                          onBlur={(event) => setcurrentSurname(event.target.value)}
                          autoComplete="new-password"
                        />
                      </Form.Group>
                    </Col>
                    <Col md="3">
                      <Form.Group>
                        <Form.Label>Pronouns</Form.Label>
                        <Form.Control
                          type="text"
                          name="profilePronouns"
                          defaultValue={currentPronouns}
                          onBlur={(event) => setcurrentPronouns(event.target.value)}
                          autoComplete="new-password"
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    {currentProviderType !== "Supervision" ? (
                      <Col md="2">
                        <Form.Group>
                          <Form.Label>Gender</Form.Label>
                          <Form.Control as="select" defaultValue={currentGender} onBlur={(event) => setcurrentGender(event.target.value)}>
                            <option value="Male">Male</option>
                            <option value="Female">Female</option>
                            <option value="Other">Other</option>
                            <option value="Prefer not to say">Prefer not to say</option>
                          </Form.Control>
                        </Form.Group>
                      </Col>
                    ) : null}
                    {currentProviderType !== "Supervision" ? (
                      <Col md="2">
                        <Form.Group>
                          <Form.Label>Date of Birth</Form.Label>
                          <Form.Control
                            type="date"
                            name="profileDOB"
                            defaultValue={currentDOB}
                            onBlur={(event) => setcurrentDOB(event.target.value)}
                            autoComplete="new-password"
                          />
                        </Form.Group>
                      </Col>
                    ) : null}
                    <Col md="4">
                      <Form.Group style={{ width: "100%" }}>
                        <Form.Label>TimeZone</Form.Label>
                        <Autocomplete
                          id="profileTimeZone"
                          variant="outlined"
                          options={timeZone}
                          getOptionLabel={(option) => option.name}
                          value={timeZone.find((v) => v.systemName === currentTimeZone) || ""}
                          onChange={(event, newValue) => handleTimeZoneAutocompleteChange("profileTimeZone", event, newValue)}
                          style={{
                            fullWidth: true,
                            display: "flex",
                            wrap: "nowrap",
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              type="text"
                              variant="outlined"
                              margin="dense"
                              name="TimeZoneSelector"
                              style={{
                                backgroundColor: "white",
                                margin: 0,
                                padding: 0,
                              }}
                              inputProps={{
                                ...params.inputProps,
                                autoComplete: "new-password",
                              }}
                            />
                          )}
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="6">
                      <Form.Group>
                        <Form.Label>Email (or UserName (Mobile) if no Email)</Form.Label>
                        <Form.Control
                          type="text"
                          name="profileEmail"
                          defaultValue={currentEmail}
                          onBlur={(event) => setcurrentEmail(event.target.value)}
                          autoComplete="new-password"
                        />
                      </Form.Group>
                    </Col>
                    <Col md="3">
                      <Form.Group>
                        <Form.Label>Contact Phone Number</Form.Label>
                        <Form.Control
                          type="text"
                          name="profileMobile"
                          defaultValue={currentMobile}
                          onBlur={(event) => setcurrentMobile(event.target.value)}
                          autoComplete="new-password"
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="6">
                      <Form.Group style={{ width: "100%" }}>
                        <Form.Label>Home Address</Form.Label>
                        <PlacesAutoComplete
                          currentID={currentID}
                          currentfulladdress={currentfulladdress}
                          setcurrentfulladdress={setcurrentfulladdress}
                          setcurrentLatitude={setcurrentLatitude}
                          setcurrentLongitude={setcurrentLongitude}
                          setcurrentPostCode={setcurrentPostCode}
                        />
                      </Form.Group>
                    </Col>
                    {currentProviderType !== "Supervision" && currentSpecialistType !== "centralisedservice" ? (
                      <Col md="3">
                        <Form.Group>
                          <Form.Label>Occupation</Form.Label>
                          <Form.Control
                            type="text"
                            name="profileOccupation"
                            defaultValue={currentOccupation}
                            onBlur={(event) => setcurrentOccupation(event.target.value)}
                            autoComplete="new-password"
                          />
                        </Form.Group>
                      </Col>
                    ) : null}
                  </Row>
                  <Row>
                    <Col md="6">
                      <Form.Group>
                        <Form.Label>Do you identify as Aboriginal and/or Torres Strait islander</Form.Label>
                        <Form.Control as="select" defaultValue={currentIndigenous} onBlur={(event) => setcurrentIndigenous(event.target.value)}>
                          <option value="N">No</option>
                          <option value="Y">Yes</option>
                        </Form.Control>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    {currentProviderType !== "Financial" && currentProviderType !== "Supervision" ? (
                      <>
                        <Col md="3">
                          <Form.Group style={{ width: "100%" }}>
                            <Form.Label>Funding Type</Form.Label>
                            <Form.Control as="select" defaultValue={currentPaymentType} onChange={(event) => setcurrentPaymentType(event.target.value)}>
                              <option value="Bulk Billed">Bulk Billed</option>
                              <option value="Reduced Gap">Reduced Gap</option>
                              <option value="Full Fee">Full Fee</option>
                              <option value="NDIS">NDIS</option>
                              <option value="Contract" disabled>
                                Contract
                              </option>
                              <option value="EAP" disabled>
                                EAP
                              </option>
                              <option value="TAC" disabled>
                                Transport Accident Commmission
                              </option>
                              <option value="WorkCover" disabled>
                                Work Cover
                              </option>
                              <option value="DVA" disabled>
                                Department of Veterans` Affairs
                              </option>
                              <option value="Island">Island (Cocos and Christmas Islands)</option>
                            </Form.Control>
                          </Form.Group>
                        </Col>
                        {currentPaymentType === "Contract" ? (
                          <Col md="3">
                            <Form.Group style={{ width: "100%" }}>
                              <Form.Label>Specialist Type</Form.Label>
                              <Form.Control as="select" defaultValue={currentSpecialistType} disabled>
                                <option value="nthqldphn">NthQLDPHN</option>
                                <option value="centralisedservice">Centralised Service</option>
                                <option value="standard">Standard</option>
                              </Form.Control>
                            </Form.Group>
                          </Col>
                        ) : null}
                        {currentSpecialistType === "centralisedservice" ? (
                          <>
                            <Col md="3">
                              <Form.Group>
                                <Form.Label>Centre Client ID</Form.Label>
                                <Form.Control type="text" name="profilecentreClientId" defaultValue={currentCentreClientId} readOnly />
                              </Form.Group>
                            </Col>
                            <Col md="3">
                              <Form.Group style={{ width: "100%" }}>
                                <Form.Label>Centre</Form.Label>
                                <Autocomplete
                                  id="csCentre"
                                  variant="outlined"
                                  options={csCentres}
                                  getOptionLabel={(option) => option.centerName}
                                  value={currentCSCentre}
                                  style={{
                                    fullWidth: true,
                                    display: "flex",
                                    wrap: "nowrap",
                                  }}
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      type="text"
                                      variant="outlined"
                                      margin="dense"
                                      name="csCentreSelector"
                                      style={{
                                        backgroundColor: "white",
                                        margin: 0,
                                        padding: 0,
                                      }}
                                      inputProps={{
                                        ...params.inputProps,
                                        autoComplete: "new-password",
                                      }}
                                      disabled
                                    />
                                  )}
                                />
                              </Form.Group>
                            </Col>
                          </>
                        ) : (
                          <Col md="6">
                            <Form.Group style={{ width: "100%" }}>
                              <Form.Label>Program (Set by RHC Admin)</Form.Label>
                              <Autocomplete
                                id="ProgramID"
                                variant="outlined"
                                options={programs}
                                getOptionLabel={(option) => option.name}
                                getOptionSelected={(option, value) => getProgramOption(option, value)}
                                value={currentClientProgram}
                                style={{
                                  fullWidth: true,
                                  display: "flex",
                                  wrap: "nowrap",
                                  backgroundColor: "white",
                                }}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    type="text"
                                    variant="outlined"
                                    margin="dense"
                                    name="currentProgramID"
                                    style={{
                                      backgroundColor: "",
                                      margin: 0,
                                      padding: 0,
                                    }}
                                    inputProps={{
                                      ...params.inputProps,
                                      autoComplete: "new-password",
                                    }}
                                    disabled
                                  />
                                )}
                              />
                            </Form.Group>
                          </Col>
                        )}
                      </>
                    ) : null}
                    {currentPaymentType === "Contract" || currentPaymentType === "EAP" ? (
                      <Col md="2">
                        <Form.Group>
                          <Form.Label>Contract Provider Fee</Form.Label>
                          <Form.Control type="text" name="contractproviderfee" defaultValue={currentContractProviderFee} readOnly />
                        </Form.Group>
                      </Col>
                    ) : null}
                  </Row>
                  {currentSpecialistType === "centralisedservice" ? (
                    <>
                      <Row>
                        <Col md="4">
                          <Form.Group>
                            <Form.Label>Translator Required</Form.Label>
                            <Form.Control as="select" name="profiletranslator" defaultValue={currentTranslator} disabled>
                              <option value="No">No</option>
                              <option value="Yes">Yes</option>
                            </Form.Control>
                          </Form.Group>
                        </Col>
                        {currentTranslator === "Yes" ? (
                          <Col md="6">
                            <Form.Group>
                              <Form.Label>Language</Form.Label>
                              <Form.Control type="text" name="profiletranslatorLanguage" defaultValue={currentTranslatorLanguage} readOnly />
                            </Form.Group>
                          </Col>
                        ) : null}
                      </Row>
                      <Row>
                        <Col md="4">
                          <Form.Group>
                            <Form.Label>Support Person Required *</Form.Label>
                            <Form.Control as="select" name="profilesupportPerson" defaultValue={currentSupportPerson} disabled>
                              <option value="No">No</option>
                              <option value="Yes">Yes</option>
                            </Form.Control>
                          </Form.Group>
                        </Col>
                        {currentSupportPerson === "Yes" ? (
                          <Col md="6">
                            <Form.Group>
                              <Form.Label>Type of support person</Form.Label>
                              <Form.Control type="text" name="profilesupportPersonDetail" defaultValue={currentSupportPersonDetail} readOnly />
                            </Form.Group>
                          </Col>
                        ) : null}
                      </Row>
                    </>
                  ) : null}
                  {currentPaymentType === "Contract" || currentPaymentType === "EAP" ? (
                    <>
                      {currentSpecialistType === "nthqldphn" ? (
                        <>
                          <Row>
                            <Col md="12">
                              <Form.Label style={{ color: "green", fontWeight: 500 }}>Nth QLD PHN Booking Management for this client</Form.Label>
                            </Col>
                          </Row>
                          <Row>
                            <Col md="2">
                              <Form.Group>
                                <Form.Label>Estimated Total</Form.Label>
                                <Form.Control
                                  type="text"
                                  name="profileNthQLDPHNBookings"
                                  defaultValue={currentNthQLDPHNBookings}
                                  onBlur={(event) => setcurrentNthQLDPHNBookings(event.target.value)}
                                  autoComplete="new-password"
                                />
                              </Form.Group>
                            </Col>
                            <Col md="2">
                              <Form.Group>
                                <Form.Label>Total To Date</Form.Label>
                                <Form.Control type="text" name="profileNthQLDPHNTotal" defaultValue={currentNthQLDPHNTotal} readOnly />
                              </Form.Group>
                            </Col>
                            <Col md="2">
                              <Form.Group>
                                <Form.Label>Past Bookings</Form.Label>
                                <Form.Control type="text" name="profileNthQLDPHNPast" defaultValue={currentNthQLDPHNPast} readOnly />
                              </Form.Group>
                            </Col>
                            <Col md="2">
                              <Form.Group>
                                <Form.Label>Future Bookings</Form.Label>
                                <Form.Control type="text" name="profileNthQLDPHNFuture" defaultValue={currentNthQLDPHNFuture} readOnly />
                              </Form.Group>
                            </Col>
                          </Row>
                        </>
                      ) : null}
                    </>
                  ) : null}
                  {programPopulationOptions && currentProgram ? (
                    <Row>
                      <Col md="12">
                        <Form.Group>
                          <Form.Label>
                            Do you identify as any of the following populations that we are particularly supporting via this program? (select all that apply)
                          </Form.Label>
                          <Row>
                            <Col md="6">
                              <List className={classes.root}>
                                {programPopulationOptions.map((row) => {
                                  if (row.index <= programPopulationOptions.length / 2) {
                                    const labelId = `checkbox-list-label-${row.id}`;
                                    var isChecked = currentProgramPopulation.find((r) => r.id === row.id);
                                    return (
                                      <ListItem key={row.id} role={undefined} dense button onClick={handleToggle(row)}>
                                        <ListItemIcon style={{ minWidth: 40 }}>
                                          <Checkbox
                                            edge="start"
                                            checked={isChecked !== undefined}
                                            tabIndex={-1}
                                            disableRipple
                                            inputProps={{
                                              "aria-labelledby": labelId,
                                            }}
                                          />
                                        </ListItemIcon>
                                        <ListItemText
                                          id={labelId}
                                          style={{ fontSize: 12 }}
                                          disableTypography
                                          primary={
                                            <Typography className={isChecked !== undefined ? classes.linkSelected : classes.link}>{row.name}</Typography>
                                          }
                                          className={classes.link}
                                        />
                                      </ListItem>
                                    );
                                  } else {
                                    return null;
                                  }
                                })}
                              </List>
                            </Col>
                            <Col md="6">
                              <List className={classes.root}>
                                {programPopulationOptions.map((row) => {
                                  if (row.index > programPopulationOptions.length / 2) {
                                    const labelId = `checkbox-list-label-${row.id}`;
                                    var isChecked = currentProgramPopulation.find((r) => r.id === row.id);
                                    return (
                                      <ListItem key={row.id} role={undefined} dense button onClick={handleToggle(row)}>
                                        <ListItemIcon style={{ minWidth: 40 }}>
                                          <Checkbox
                                            edge="start"
                                            checked={isChecked !== undefined}
                                            tabIndex={-1}
                                            disableRipple
                                            inputProps={{
                                              "aria-labelledby": labelId,
                                            }}
                                          />
                                        </ListItemIcon>
                                        <ListItemText
                                          id={labelId}
                                          style={{ fontSize: 12 }}
                                          disableTypography
                                          primary={
                                            <Typography className={isChecked !== undefined ? classes.linkSelected : classes.link}>{row.name}</Typography>
                                          }
                                          className={classes.link}
                                        />
                                      </ListItem>
                                    );
                                  } else {
                                    return null;
                                  }
                                })}
                              </List>
                            </Col>
                          </Row>
                        </Form.Group>
                      </Col>
                    </Row>
                  ) : null}
                  {currentProviderType !== "GP" && currentProviderType !== "Supervision" && currentSpecialistType !== "centralisedservice" ? (
                    <>
                      <Row>
                        <Col md="12">
                          <Form.Group>
                            <Form.Label>Areas of Interest (Select all that apply) </Form.Label>
                            <Autocomplete
                              id="searchAOI"
                              variant="outlined"
                              multiple
                              options={areasOfInterest}
                              getOptionLabel={(option) => option.issue}
                              value={currentAreasOfInterest}
                              onChange={(event, newValue) => setcurrentAreasOfInterest(newValue)}
                              style={{
                                fullWidth: true,
                                display: "flex",
                                wrap: "nowrap",
                                backgroundColor: "white",
                              }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  type="text"
                                  variant="outlined"
                                  margin="dense"
                                  name="AOISelector"
                                  style={{
                                    backgroundColor: "",
                                    margin: 0,
                                    padding: 0,
                                  }}
                                  inputProps={{
                                    ...params.inputProps,
                                    autoComplete: "new-password",
                                  }}
                                />
                              )}
                            />
                          </Form.Group>
                        </Col>
                      </Row>
                    </>
                  ) : null}
                  {currentSpecialistType !== "centralisedservice" ? (
                    <Row>
                      <Col md="12">
                        <Form.Group>
                          {currentProviderType !== "Supervision" ? (
                            <>
                              <Form.Label>What are you hoping to get out of your sessions?</Form.Label>
                            </>
                          ) : (
                            <Form.Label>
                              Details on the type of supervision you are after, where you are currently practicing and other relevant information.
                            </Form.Label>
                          )}
                          <Form.Control
                            as="textarea"
                            rows={4}
                            type="text"
                            name="profilehopeToGetFromTreatment"
                            defaultValue={currentHopeToGetFromTreatment}
                            onBlur={(event) => setcurrentHopeToGetFromTreatment(event.target.value)}
                            autoComplete="new-password"
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                  ) : null}
                  {currentHandOverNotes && currentHandOverNotes.length > 2 ? (
                    <Row>
                      <Col md="12">
                        <Form.Group>
                          <Form.Label>Handover Notes </Form.Label>
                          <Form.Control as="textarea" rows={4} type="text" name="profilehandOverNotes" readOnly defaultValue={currentHandOverNotes} />
                        </Form.Group>
                      </Col>
                    </Row>
                  ) : null}
                  {/* <Row>
                    <Col md="10">
                      <Form.Group controlId="currentMedicalPractitioner.address">
                        <Form.Label>Address - may need to add this </Form.Label>
                          <Form.Control type="text" name="address" value={currentMedicalPractitioner ? currentMedicalPractitioner.address : ''} readOnly />
                      </Form.Group>
                    </Col>
                  </Row> */}
                  {currentProviderType === "Financial" ? (
                    <>
                      <Row>
                        <Col md="3">
                          <Form.Group>
                            <Form.Label>Business Name</Form.Label>
                            <Form.Control type="text" name="businessName" readOnly defaultValue={currentBusinessName || ""} />
                          </Form.Group>
                        </Col>
                        <Col md="3">
                          <Form.Group>
                            <Form.Label>ABN</Form.Label>
                            <Form.Control type="text" name="abn" readOnly defaultValue={currentABN || ""} />
                          </Form.Group>
                        </Col>
                        <Col md="6">
                          <Form.Group>
                            <Form.Label>Business Address</Form.Label>
                            <Form.Control type="text" name="businessAddress" readOnly defaultValue={currentBusinessAddress || ""} />
                          </Form.Group>
                        </Col>
                      </Row>
                      <Row>
                        <Col md="12">
                          <Form.Group>
                            <Form.Label>Background Information</Form.Label>
                            <Form.Control
                              as="textarea"
                              rows={4}
                              type="text"
                              readOnly
                              name="backgroundinformation"
                              defaultValue={currentBackgroundInformation}
                              autoComplete="new-password"
                            />
                          </Form.Group>
                        </Col>
                      </Row>
                    </>
                  ) : null}

                  {currentProviderType !== "Financial" && currentProviderType !== "Supervision" ? (
                    <>
                      <Row>
                        <Col md="4">
                          <Form.Group>
                            <Form.Label>Emergency Contact 1</Form.Label>
                            <Form.Control
                              type="text"
                              name="emergencycontactname1"
                              defaultValue={currentEmergencyContactName1 || ""}
                              onBlur={(event) => setcurrentEmergencyContactName1(event.target.value)}
                              autoComplete="new-password"
                            />
                          </Form.Group>
                        </Col>
                        <Col md="4">
                          <Form.Group>
                            <Form.Label>Relationship</Form.Label>
                            <Form.Control
                              type="text"
                              name="emergencycontactrelation1"
                              defaultValue={currentEmergencyContactRelation1 || ""}
                              onBlur={(event) => setcurrentEmergencyContactRelation1(event.target.value)}
                              autoComplete="new-password"
                            />
                          </Form.Group>
                        </Col>
                        <Col md="4">
                          <Form.Group>
                            <Form.Label>Phone</Form.Label>
                            <Form.Control
                              type="text"
                              name="emergencycontactphone1"
                              defaultValue={currentEmergencyContactPhone1 || ""}
                              onBlur={(event) => setcurrentEmergencyContactPhone1(event.target.value)}
                              autoComplete="new-password"
                            />
                          </Form.Group>
                        </Col>
                      </Row>
                      <Row>
                        <Col md="4">
                          <Form.Group>
                            <Form.Label>Emergency Contact 2</Form.Label>
                            <Form.Control
                              type="text"
                              name="emergencycontactname2"
                              defaultValue={currentEmergencyContactName2 || ""}
                              onBlur={(event) => setcurrentEmergencyContactName2(event.target.value)}
                              autoComplete="new-password"
                            />
                          </Form.Group>
                        </Col>
                        <Col md="4">
                          <Form.Group>
                            <Form.Label>Relationship</Form.Label>
                            <Form.Control
                              type="text"
                              name="emergencyrelation2"
                              defaultValue={currentEmergencyContactRelation2 || ""}
                              onBlur={(event) => setcurrentEmergencyContactRelation2(event.target.value)}
                              autoComplete="new-password"
                            />
                          </Form.Group>
                        </Col>
                        <Col md="4">
                          <Form.Group>
                            <Form.Label>Phone</Form.Label>
                            <Form.Control
                              type="text"
                              name="emergencycontactphone2"
                              defaultValue={currentEmergencyContactPhone2 || ""}
                              onBlur={(event) => setcurrentEmergencyContactPhone2(event.target.value)}
                              autoComplete="new-password"
                            />
                          </Form.Group>
                        </Col>
                      </Row>
                    </>
                  ) : null}
                  {currentPaymentType === "NDIS" ? (
                    <>
                      <h5 style={{ paddingBottom: 20 }}>Billing Information</h5>
                      <Row>
                        <Col md="3">
                          <Form.Group>
                            <Form.Label>NDIS Number</Form.Label>
                            <Form.Control
                              type="text"
                              name="ndisnumber"
                              defaultValue={currentNDISNumber || ""}
                              onBlur={(event) => setcurrentNDISNumber(event.target.value)}
                              autoComplete="new-password"
                            />
                          </Form.Group>
                        </Col>
                        <Col md="3">
                          <Form.Group>
                            <Form.Label>NDIS Date From</Form.Label>
                            <Form.Control
                              type="date"
                              name="profileNDISDateFrom"
                              defaultValue={currentNDISDateFrom}
                              onBlur={(event) => setcurrentNDISDateFrom(event.target.value)}
                              autoComplete="new-password"
                            />
                          </Form.Group>
                        </Col>
                        <Col md="3">
                          <Form.Group>
                            <Form.Label>To</Form.Label>
                            <Form.Control
                              type="date"
                              name="profileNDISDateTo"
                              defaultValue={currentNDISDateTo}
                              onBlur={(event) => setcurrentNDISDateTo(event.target.value)}
                              autoComplete="new-password"
                            />
                          </Form.Group>
                        </Col>
                        <Col md="3">
                          <Form.Group>
                            <Form.Label>NDIS Total Fee</Form.Label>
                            <Form.Control
                              type="text"
                              name="ndisbookingfee"
                              defaultValue={currentNDISBookingFee || ""}
                              onBlur={(event) => setcurrentNDISBookingFee(event.target.value)}
                              autoComplete="new-password"
                            />
                          </Form.Group>
                        </Col>
                      </Row>
                      <Row>
                        <Col md="6">
                          <Form.Group>
                            <Form.Label>NDIS Plan Management Provider</Form.Label>
                            <Form.Control
                              type="text"
                              name="profileNDISPlanManagementProvider"
                              defaultValue={currentNDISPlanManagementProvider}
                              onBlur={(event) => setcurrentNDISPlanManagementProvider(event.target.value)}
                              autoComplete="new-password"
                            />
                          </Form.Group>
                        </Col>
                        <Col md="6">
                          <Form.Group>
                            <Form.Label>NDIS Invoice Email</Form.Label>
                            <Form.Control
                              type="text"
                              name="profileNDISEmailForInvoices"
                              defaultValue={currentNDISEmailForInvoices}
                              onBlur={(event) => setcurrentNDISEmailForInvoices(event.target.value)}
                              autoComplete="new-password"
                            />
                          </Form.Group>
                        </Col>
                      </Row>
                      <Row>
                        <Col md="6">
                          <Form.Group>
                            <Form.Label>NDIS Support Coordinator</Form.Label>
                            <Form.Control
                              type="text"
                              name="profileNDISSupportCoordinator"
                              defaultValue={currentNDISSupportCoordinator}
                              onBlur={(event) => setcurrentNDISSupportCoordinator(event.target.value)}
                              autoComplete="new-password"
                            />
                          </Form.Group>
                        </Col>
                        <Col md="3">
                          <Form.Group>
                            <Form.Label>NDIS Support Coordinator Phone</Form.Label>
                            <Form.Control
                              type="text"
                              name="profileNDISSupportCoordinatorPhone"
                              defaultValue={currentNDISSupportCoordinatorPhone}
                              onBlur={(event) => setcurrentNDISSupportCoordinatorPhone(event.target.value)}
                              autoComplete="new-password"
                            />
                          </Form.Group>
                        </Col>
                        <Col md="3">
                          <Form.Group>
                            <Form.Label>NDIS Item Code</Form.Label>
                            <Form.Control
                              type="text"
                              name="profileRHCNDISItemCode"
                              defaultValue={currentRHCNDISItemCode}
                              onBlur={(event) => setcurrentRHCNDISItemCode(event.target.value)}
                              autoComplete="new-password"
                            />
                          </Form.Group>
                        </Col>
                      </Row>
                      <Row>
                        <Col md="12">
                          <Form.Group>
                            <Form.Label>NDIS Billing Note</Form.Label>
                            <Form.Control
                              as="textarea"
                              rows={4}
                              type="text"
                              name="currentNDISBillingNote"
                              defaultValue={currentNDISBillingNote}
                              onBlur={(event) => setcurrentNDISBillingNote(event.target.value)}
                              autoComplete="new-password"
                            />
                          </Form.Group>
                        </Col>
                      </Row>
                    </>
                  ) : null}

                  {currentProviderType !== "Financial" ? (
                    <>
                      <Row>
                        {currentPaymentType !== "Contract" &&
                        currentPaymentType !== "NDIS" &&
                        currentPaymentType !== "EAP" &&
                        currentProviderType !== "Supervision" ? (
                          <>
                            <Col md="3">
                              <Form.Group>
                                <Form.Label>Medicare Card Number</Form.Label>
                                <Form.Control
                                  type="text"
                                  name="medicareno"
                                  defaultValue={currentmedicareno || ""}
                                  onBlur={(event) => setcurrentmedicareno(event.target.value)}
                                  autoComplete="new-password"
                                />
                              </Form.Group>
                            </Col>
                            <Col md="3">
                              <Form.Group>
                                <Form.Label>Order on Card</Form.Label>
                                <Form.Control
                                  type="text"
                                  name="medicarereferenceno"
                                  defaultValue={currentmedicarereferenceno || ""}
                                  onBlur={(event) => setcurrentmedicarereferenceno(event.target.value)}
                                  autoComplete="new-password"
                                />
                              </Form.Group>
                            </Col>
                            <Col md="3">
                              <Form.Group>
                                <Form.Label>Medicare Expiry Date</Form.Label>
                                <Form.Control
                                  type="text"
                                  name="medicareexpirydate"
                                  defaultValue={currentmedicareexpirydate || ""}
                                  onBlur={(event) => setcurrentmedicareexpirydate(event.target.value)}
                                  autoComplete="new-password"
                                />
                              </Form.Group>
                            </Col>
                          </>
                        ) : null}
                        <Col md="3">
                          <Form.Group>
                            <Form.Label>Appointment Type</Form.Label>
                            <Select
                              variant="outlined"
                              margin="dense"
                              id="appointmentType"
                              aria-label="Select Appointment Type"
                              name="appointmentType"
                              value={currentAppointmentType}
                              onChange={(event) => handleAppointmentTypeChange(event.target.value)}
                              style={{
                                fullWidth: true,
                                display: "flex",
                                wrap: "nowrap",
                                backgroundColor: "#fff",
                              }}
                            >
                              <MenuItem key="Video" value="0">
                                Video Call
                              </MenuItem>
                              <MenuItem key="Phone" value="1">
                                Phone Call
                              </MenuItem>
                            </Select>
                          </Form.Group>
                        </Col>
                      </Row>
                      <h5 style={{ paddingBottom: 20 }}>Registration Questions and Responses</h5>
                      <Row>
                        <Col md="6">
                          <Form.Group>
                            <Form.Label>
                              Have you received a Mental Health Plan in the last 12 Months ?
                              <span style={{ fontStyle: "italic", fontWeight: 600 }}>
                                (Note this question is only answered if the client registered for a GP booking - originally)
                              </span>
                            </Form.Label>
                            <Form.Control
                              type="text"
                              name="gpmentalhealthplan12months"
                              readOnly
                              style={{ width: "25%" }}
                              defaultValue={currentGPMentalHealthPlan12Months || ""}
                            />
                          </Form.Group>
                        </Col>
                      </Row>
                      {currentPaymentType === "Bulk Billed" || currentPaymentType === "Reduced Gap" ? (
                        <>
                          {currentPaymentType === "Bulk Billed" ? (
                            <>
                              <Form.Label style={{ fontStyle: "italic", fontWeight: 600 }}>
                                Note: The questions below no longer appear in the Client Registration Form but are still in the Database for older clients.{" "}
                              </Form.Label>
                              <Row>
                                <Col md="3">
                                  <Form.Group>
                                    <Form.Label>Do you have a Health Care Card?</Form.Label>
                                    <Form.Control type="text" name="healthcarecard" readOnly defaultValue={currentHealthCareCard || ""} />
                                  </Form.Group>
                                </Col>
                                <Col md="3">
                                  <Form.Group>
                                    <Form.Label>Are you Unemployed?</Form.Label>
                                    <Form.Control type="text" name="unemployed" readOnly defaultValue={currentUnemployed || ""} />
                                  </Form.Group>
                                </Col>
                                <Col md="6">
                                  <Form.Group>
                                    <Form.Label>Have you been impacted by drought, bushfire, flood or other natural disaster?</Form.Label>
                                    <Form.Control type="text" name="naturaldisaster" readOnly defaultValue={currentNaturalDisaster || ""} />
                                  </Form.Group>
                                </Col>
                              </Row>
                            </>
                          ) : null}
                          <Row>
                            <Col md="12">
                              <Form.Group>
                                <Form.Label>Please tell us why you need to be bulk billed (or reduced fee)?</Form.Label>
                                <Form.Control
                                  as="textarea"
                                  rows={4}
                                  type="text"
                                  readOnly
                                  name="bulkbilledreason"
                                  defaultValue={currentBulkBilledReason}
                                  autoComplete="new-password"
                                />
                              </Form.Group>
                            </Col>
                          </Row>
                        </>
                      ) : null}
                    </>
                  ) : null}
                </Tab>
                {currentSpecialistType === "centralisedservice" ? (
                  <Tab
                    eventKey="CSReferral"
                    title="CS Referral"
                    style={{
                      backgroundColor: "rgb(245, 245, 245)",
                      padding: 6,
                    }}
                  >
                    <h5>Referral Information</h5>
                    <Row>
                      <Col md="12">
                        <Form.Group>
                          <Form.Label>Purpose of referral *</Form.Label>
                          <Form.Control as="textarea" rows={4} type="text" name="referralPurpose" defaultValue={currentReferralPurpose} readOnly />
                          <Form.Label style={{ fontSize: 12, color: "#6c757d" }}>What would the consumer like to achieve through this referral?</Form.Label>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col md="12">
                        <Form.Group>
                          <Form.Label>Presenting concerns & relevant background*</Form.Label>
                          <Form.Control
                            as="textarea"
                            rows={4}
                            type="text"
                            name="hopeToGetFromTreatment"
                            defaultValue={currentHopeToGetFromTreatment}
                            readOnly
                          />
                          <Form.Label style={{ fontSize: 12, color: "#6c757d" }}>
                            Please provide details that support collaborative care, such as frequency of case conferences, support needs, etc. If referral
                            information is described in the IAR please refer to it.
                          </Form.Label>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col md="12">
                        <Form.Group>
                          <Form.Label>Current Medication</Form.Label>
                          <Form.Control as="textarea" rows={4} type="text" name="profileMedication" defaultValue={currentMedication} readOnly />
                          <Form.Label style={{ fontSize: 12, color: "#6c757d" }}>
                            Please provide details of client's current medication. If current medication is described in IAR please refer to it.
                          </Form.Label>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col md="12">
                        <Form.Group>
                          <Form.Label>Identified risks and agreed management strategies*</Form.Label>
                          <Form.Control
                            as="textarea"
                            rows={4}
                            type="text"
                            name="identifiedRisksAndAgreedManagement"
                            defaultValue={currentIdentifiedRisksAndAgreedManagement}
                            readOnly
                          />
                          <Form.Label style={{ fontSize: 12, color: "#6c757d" }}>
                            Please provide details about any identified risks and agreed management plans. You can find additional information and a template in
                            the Centralised Service Clinical Risk Assessment and Management Policy in the Resources tab.
                          </Form.Label>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col md="6">
                        <Form.Group style={{ width: "100%" }}>
                          <Form.Label>Centre anticipated end of care*</Form.Label>
                          <Form.Control type="text" name="currentEstimatedEndOfCareDate" defaultValue={currentEstimatedEndOfCareDate} readOnly />
                        </Form.Group>
                      </Col>
                      {/* <Col md="6">
                      <Form.Group>
                        <Form.Label>Estimated total number of sessions</Form.Label>
                        <Form.Control type="text" name="csSessionExpectation" defaultValue={currentCsSessionExpect} readOnly />
                      </Form.Group>
                    </Col> */}
                    </Row>
                    <Row>
                      <Col md="12">
                        <Form.Group>
                          <Form.Label>MMHC contact and process expectations*</Form.Label>
                          <Form.Control as="textarea" rows={4} type="text" name="referralInformation" defaultValue={currentReferralInformation} readOnly />
                          <Form.Label style={{ fontSize: 12, color: "#6c757d" }}>
                            Please provide details of the contact and process expectations. If current process expectations are described in the IAR, please
                            refer to it.
                          </Form.Label>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col md="12">
                        <Form.Group>
                          <Form.Label>Special Circumstances</Form.Label>
                          <Form.Control as="textarea" rows={4} type="text" name="specialCircumstances" defaultValue={currentSpecialCircumstances} readOnly />
                          <Form.Label style={{ fontSize: 12, color: "#6c757d" }}>
                            Please provide details of any special circumstances. If relevant details are described in the IAR, please refer to it.
                          </Form.Label>
                        </Form.Group>
                      </Col>
                    </Row>

                    <h5>Assessments</h5>
                    <Row>
                      <Col md="6">
                        <Form.Group>
                          <Form.Label>Initial Assessment Status</Form.Label>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "2rem",
                            }}
                          >
                            <span
                              className="text-muted"
                              style={{
                                fontSize: "1rem",
                                fontWeight: "bold",
                              }}
                            >
                              {currentInitalAssessmentOutcome || "Not Set"}
                            </span>
                          </div>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col md="6">
                        <Form.Group>
                          <Form.Label>IAR Upload Status</Form.Label>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "2rem",
                            }}
                          >
                            <span
                              className="text-muted"
                              style={{
                                fontSize: "1rem",
                                fontWeight: "bold",
                              }}
                            >
                              {currentRecentIARFileURL || "No Upload"}
                            </span>
                          </div>
                        </Form.Group>
                      </Col>
                    </Row>
                  </Tab>
                ) : null}

                {currentProviderType !== "Financial" && currentProviderType !== "Supervision" ? (
                  <Tab
                    eventKey="clientGP"
                    title="GP"
                    style={{
                      backgroundColor: "rgb(245, 245, 245)",
                      padding: 6,
                    }}
                  >
                    <>
                      {/* Medical Practitioner */}
                      {(currentProviderType !== "Provisional" && currentProviderType !== "GP") || currentSpecialistType === "centralisedservice" ? (
                        <>
                          <Row>
                            <Col md="4">
                              <h4>Client's GP</h4>
                            </Col>
                            <Col md="2" style={{ textAlign: "right" }}>
                              <SearchIcon style={{ marginTop: 8, marginRight: -13 }} />
                            </Col>
                            <Col md="6">
                              <Form.Group style={{ width: "100%", marginBottom: 0 }}>
                                <Autocomplete
                                  id="profileMedicalPractitionerID"
                                  variant="outlined"
                                  options={medicalPractitioners}
                                  getOptionLabel={(option) => option.fullname}
                                  getOptionSelected={(option, value) => getMedicalPractitionerOption(option, value)}
                                  value={currentMedicalPractitioner}
                                  onChange={(event, newValue) => loadMedicalPractitioner(newValue)}
                                  style={{
                                    fullWidth: true,
                                    display: "flex",
                                    wrap: "nowrap",
                                  }}
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      type="text"
                                      variant="outlined"
                                      margin="dense"
                                      name="MedicalPractitionerSelector"
                                      style={{
                                        backgroundColor: "",
                                        margin: 0,
                                        padding: 0,
                                      }}
                                      inputProps={{
                                        ...params.inputProps,
                                        autoComplete: "new-password",
                                      }}
                                    />
                                  )}
                                />
                              </Form.Group>
                            </Col>
                          </Row>
                          <hr></hr>
                          <Row>
                            <Col md="3">
                              <Form.Group controlId="currentMedicalPractitionerFirstName">
                                <Form.Label>Firstname</Form.Label>
                                <Form.Control
                                  type="text"
                                  name="firstName"
                                  value={currentMedicalPractitioner.firstName}
                                  onChange={(event) =>
                                    setcurrentMedicalPractitioner({
                                      ...currentMedicalPractitioner,
                                      firstName: event.target.value,
                                    })
                                  }
                                  autoComplete="new-password"
                                />
                              </Form.Group>
                            </Col>
                            <Col md="3">
                              <Form.Group controlId="currentMedicalPractitionerSurname">
                                <Form.Label>Surname</Form.Label>
                                <Form.Control
                                  type="text"
                                  name="surname"
                                  value={currentMedicalPractitioner.surname}
                                  onChange={(event) =>
                                    setcurrentMedicalPractitioner({
                                      ...currentMedicalPractitioner,
                                      surname: event.target.value,
                                    })
                                  }
                                  autoComplete="new-password"
                                />
                              </Form.Group>
                            </Col>
                            <Col md="3">
                              <Form.Group controlId="currentMedicalPractitionerMobilePhone">
                                <Form.Label>Mobile Phone</Form.Label>
                                <Form.Control
                                  type="text"
                                  name="mobilephone"
                                  value={currentMedicalPractitioner.mobilephone}
                                  onChange={(event) =>
                                    setcurrentMedicalPractitioner({
                                      ...currentMedicalPractitioner,
                                      mobilephone: event.target.value,
                                    })
                                  }
                                  autoComplete="new-password"
                                />
                              </Form.Group>
                            </Col>
                            <Col md="3">
                              <Form.Group controlId="currentMedicalPractitionerProviderNo">
                                <Form.Label>Provider Number</Form.Label>
                                <Form.Control
                                  type="text"
                                  name="providernumber"
                                  value={currentMedicalPractitioner.providernumber}
                                  onChange={(event) =>
                                    setcurrentMedicalPractitioner({
                                      ...currentMedicalPractitioner,
                                      providernumber: event.target.value,
                                    })
                                  }
                                  autoComplete="new-password"
                                />
                              </Form.Group>
                            </Col>
                          </Row>
                          {/* Medical Practice */}
                          <Row>
                            <Col md="4">
                              <h4>Practice</h4>
                            </Col>
                            <Col md="2" style={{ textAlign: "right" }}>
                              <SearchIcon style={{ marginTop: 8, marginRight: -13 }} />
                            </Col>
                            <Col md="6">
                              <Form.Group style={{ width: "100%", marginBottom: 0 }}>
                                <Autocomplete
                                  id="profileMedicalPractice"
                                  variant="outlined"
                                  options={medicalPractices}
                                  getOptionLabel={(option) => option.practicename}
                                  getOptionSelected={(option, value) => getMedicalPracticeOption(option, value)}
                                  value={currentMedicalPractice}
                                  onChange={(event, newValue) => loadMedicalPractitice(newValue)}
                                  style={{
                                    fullWidth: true,
                                    display: "flex",
                                    wrap: "nowrap",
                                  }}
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      type="text"
                                      variant="outlined"
                                      margin="dense"
                                      name="MedicalPracticeSelector"
                                      style={{
                                        backgroundColor: "",
                                        margin: 0,
                                        padding: 0,
                                      }}
                                      inputProps={{
                                        ...params.inputProps,
                                        autoComplete: "new-password",
                                      }}
                                    />
                                  )}
                                />
                              </Form.Group>
                            </Col>
                          </Row>
                          <hr></hr>
                          <Row>
                            <Col md="5">
                              <Form.Group>
                                <Form.Label>Clinic Name</Form.Label>
                                <Form.Control
                                  type="text"
                                  name="practicename"
                                  value={currentMedicalPractice ? currentMedicalPractice.practicename : ""}
                                  onChange={(event) =>
                                    setcurrentMedicalPractice({
                                      ...currentMedicalPractice,
                                      practicename: event.target.value,
                                    })
                                  }
                                  autoComplete="new-password"
                                />
                              </Form.Group>
                            </Col>
                            <Col md="3">
                              <Form.Group>
                                <Form.Label>ABN</Form.Label>
                                <Form.Control
                                  type="text"
                                  name="currentAbn"
                                  value={currentMedicalPractice ? currentMedicalPractice.abn : ""}
                                  onChange={(event) =>
                                    setcurrentMedicalPractice({
                                      ...currentMedicalPractice,
                                      abn: event.target.value,
                                    })
                                  }
                                  autoComplete="new-password"
                                />
                              </Form.Group>
                            </Col>
                            <Col md="3">
                              <Form.Group>
                                <Form.Label>Contact Phone</Form.Label>
                                <Form.Control
                                  type="text"
                                  name="currentPhone"
                                  value={currentMedicalPractice ? currentMedicalPractice.phone : ""}
                                  onChange={(event) =>
                                    setcurrentMedicalPractice({
                                      ...currentMedicalPractice,
                                      phone: event.target.value,
                                    })
                                  }
                                  autoComplete="new-password"
                                />
                              </Form.Group>
                            </Col>
                          </Row>
                          <Row>
                            <Col md="6">
                              <Form.Group>
                                <Form.Label>Clinic Address</Form.Label>
                                <Form.Control
                                  type="text"
                                  name="currentAddress1"
                                  value={currentMedicalPractice ? currentMedicalPractice.address1 : ""}
                                  onChange={(event) =>
                                    setcurrentMedicalPractice({
                                      ...currentMedicalPractice,
                                      address1: event.target.value,
                                    })
                                  }
                                  autoComplete="new-password"
                                />
                              </Form.Group>
                            </Col>
                            <Col md="3">
                              <Form.Group>
                                <Form.Label>Clinic Fax</Form.Label>
                                <Form.Control
                                  type="text"
                                  name="currentFax"
                                  value={currentMedicalPractice ? currentMedicalPractice.fax : ""}
                                  onChange={(event) =>
                                    setcurrentMedicalPractice({
                                      ...currentMedicalPractice,
                                      fax: event.target.value,
                                    })
                                  }
                                  autoComplete="new-password"
                                />
                              </Form.Group>
                            </Col>
                            <Col md="3">
                              <Form.Group>
                                <Form.Label>Clinic Email</Form.Label>
                                <Form.Control
                                  type="text"
                                  name="currentEmail"
                                  value={currentMedicalPractice ? currentMedicalPractice.email : ""}
                                  onChange={(event) =>
                                    setcurrentMedicalPractice({
                                      ...currentMedicalPractice,
                                      email: event.target.value,
                                    })
                                  }
                                  autoComplete="new-password"
                                />
                              </Form.Group>
                            </Col>
                          </Row>
                        </>
                      ) : (
                        <>
                          <Row>
                            <Col md="4">
                              <h4>Client's GP</h4>
                            </Col>
                          </Row>
                          <Row>
                            <Col md="3">
                              <Form.Group>
                                <Form.Label>GP Name</Form.Label>
                                <Form.Control
                                  type="text"
                                  name="profilegpname"
                                  defaultValue={currentGPName}
                                  onBlur={(event) => setcurrentGPName(event.target.value)}
                                  autoComplete="new-password"
                                />
                              </Form.Group>
                            </Col>
                            <Col md="3">
                              <Form.Group>
                                <Form.Label>GP Clinic Name</Form.Label>
                                <Form.Control
                                  type="text"
                                  name="profilegpclinicname"
                                  defaultValue={currentGPClinicName}
                                  onBlur={(event) => setcurrentGPClinicName(event.target.value)}
                                  autoComplete="new-password"
                                />
                              </Form.Group>
                            </Col>
                            <Col md="3">
                              <Form.Group>
                                <Form.Label>GP Contact Number</Form.Label>
                                <Form.Control
                                  type="text"
                                  name="profilegpcontactnumber"
                                  defaultValue={currentGPContactNumber}
                                  onBlur={(event) => setcurrentGPContactNumber(event.target.value)}
                                  autoComplete="new-password"
                                />
                              </Form.Group>
                            </Col>
                            {currentProviderType === "GP" ? (
                              <Col md="6">
                                <Form.Group>
                                  <Form.Label>Client consent to share their Mental Health Treatment Plan with their GP</Form.Label>
                                  <Form.Control
                                    as="select"
                                    name="profileconsentToShareWithGP"
                                    defaultValue={currentConsentToShareWithGP}
                                    onBlur={(event) => setcurrentConsentToShareWithGP(event.target.value)}
                                  >
                                    <option value=""></option>
                                    <option value="N">No</option>
                                    <option value="Y">Yes</option>
                                  </Form.Control>
                                </Form.Group>
                              </Col>
                            ) : null}
                          </Row>
                        </>
                      )}
                    </>
                  </Tab>
                ) : null}
                <Tab
                  eventKey="Notes"
                  title="Notes"
                  style={{
                    backgroundColor: "rgb(245, 245, 245)",
                    padding: 6,
                  }}
                >
                  <Notes
                    type="Client"
                    pkid={currentClientID}
                    firstName={currentPreferredName && currentPreferredName.length > 2 ? currentPreferredName : currentFirstName}
                    medicalPractice={currentMedicalPractice}
                    waitingRoomURL={registered && (registered.teleHealthProvider === "COVIU" ? registered.coviuRoomURL : registered.waitingRoomURL)}
                    faxGP={currentReferralGPPracticeFax}
                    ownerName={currentOwnerFirstName}
                    specialistType={currentSpecialistType}
                    email={currentEmail}
                    mobilephone={currentMobile}
                    providerTotal={currentProviderTotal}
                    viewType="NoteOnly"
                  />
                </Tab>
                <Tab eventKey="ClientScores" title="Scores" style={{ backgroundColor: "rgb(245, 245, 245)", padding: 6 }}>
                  <ClientScores clientID={currentClientID} />
                </Tab>
                <Tab eventKey="Communications" title="Communications" style={{ backgroundColor: "rgb(245, 245, 245)", padding: 6 }}>
                  <Notes
                    type="Client"
                    pkid={currentClientID}
                    firstName={currentPreferredName && currentPreferredName.length > 2 ? currentPreferredName : currentFirstName}
                    medicalPractice={currentMedicalPractice}
                    waitingRoomURL={registered && (registered.teleHealthProvider === "COVIU" ? registered.coviuRoomURL : registered.waitingRoomURL)}
                    faxGP={currentReferralGPPracticeFax}
                    ownerName={currentOwnerFirstName}
                    specialistType={currentSpecialistType}
                    email={currentEmail}
                    mobilephone={currentMobile}
                    providerTotal={currentProviderTotal}
                    viewType="CommunicationOnly"
                  />
                </Tab>
                <Tab eventKey="files" title="Files" style={{ backgroundColor: "rgb(245, 245, 245)", padding: 6 }}>
                  <Files type="Client" subtype={currentPaymentType} pkid={currentClientID} specialistType={currentSpecialistType} />
                </Tab>
                {currentProviderType !== "Financial" && currentProviderType !== "GP" ? (
                  <Tab
                    eventKey="referrals"
                    title="Referrals"
                    style={{
                      backgroundColor: "rgb(245, 245, 245)",
                      padding: 6,
                    }}
                  >
                    <ReferralMaintenance
                      viewerFullName={`${currentFirstName} ${currentSurname}`}
                      clientID={currentClientID}
                      psychologistID={registered && registered.id}
                      type={"client"}
                    />
                  </Tab>
                ) : null}
              </Tabs>
            </Form>
          </Modal.Body>
          <Modal.Footer className="editprofile-modal">
            <Button variant="secondary" onClick={() => setShow(false)}>
              Cancel
            </Button>
            <Button variant="primary" onClick={putClient}>
              Save
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal
          show={showCancelProviderBooking}
          onHide={() => setShowCancelProviderBooking(false)}
          dialogClassName="new-bookingDialog-modal"
          style={{ zIndex: 1150 }}
          centered
        >
          <Modal.Header closeButton className="new-booking-modal">
            <Modal.Title>Booking with {booking.clientfullname}</Modal.Title>
          </Modal.Header>
          <Modal.Body className="new-booking-modal" style={{ backgroundColor: "rgb(245,245,245)" }}>
            <Grid container spacing={3}>
              <Grid item md={3} xs={6}>
                Client:
              </Grid>
              <Grid item md={9} xs={6} style={{ fontWeight: 600 }}>
                {booking.clientfullname}
              </Grid>
              <Grid item md={3} xs={6}>
                Date:
              </Grid>
              <Grid item md={9} xs={6} style={{ fontWeight: 600 }}>
                {format(new Date(booking.psychologistDate ? booking.psychologistDate : null), "dd-MM-yyyy")}
              </Grid>
              <Grid item md={3} xs={6}>
                Time:
              </Grid>
              <Grid item md={9} xs={6} style={{ fontWeight: 600 }}>
                {format(new Date(booking.psychologistDate ? booking.psychologistDate : null), "h:mm aa")}
              </Grid>
              <Grid item md={3} xs={6}>
                Payment Type:
              </Grid>
              <Grid item md={9} xs={6} style={{ fontWeight: 600 }}>
                {booking.paymentType}
              </Grid>
              <hr />
              <Grid item md={12} xs={6}>
                <Form.Group>
                  <Form.Label style={{ fontWeight: 600, paddingBottom: 10 }}>Why is this booking being cancelled?</Form.Label>
                  <Form.Check id="cancellationType-NoShow" name="noShowCancellation" type="radio" style={{ marginBottom: 8 }}>
                    <Form.Check.Input
                      name="NoShow"
                      type="radio"
                      checked={cancellationType === "NoShow" ? true : false}
                      onChange={(e) => setCancellationType("NoShow")}
                    />
                    <Form.Check.Label style={{ marginLeft: 12 }}>Client did not attend </Form.Check.Label>
                  </Form.Check>
                  <Form.Check id="cancellationType-LateCancel" name="LateCancelCancellation" type="radio" style={{ marginBottom: 8 }}>
                    <Form.Check.Input
                      name="LateCancel"
                      type="radio"
                      checked={cancellationType === "LateCancel" ? true : false}
                      onChange={(e) => setCancellationType("LateCancel")}
                    />
                    <Form.Check.Label style={{ marginLeft: 12 }}>Cancellation within 24 hours by Client </Form.Check.Label>
                  </Form.Check>
                  <Form.Check id="cancellationType-Provider24" name="providerCancellation24" type="radio" style={{ marginBottom: 8 }}>
                    <Form.Check.Input
                      name="providerCancellation24"
                      type="radio"
                      checked={cancellationType === "LateCancelProvider" ? true : false}
                      onChange={(e) => setCancellationType("LateCancelProvider")}
                    />
                    <Form.Label style={{ marginLeft: 12 }}>Cancellation within 24 hours by Provider</Form.Label>
                  </Form.Check>
                  <Form.Check id="cancellationType-Provider" name="providerCancellation" type="radio" style={{ marginBottom: 8 }}>
                    <Form.Check.Input
                      name="providerCancellation"
                      type="radio"
                      checked={cancellationType === "Provider" ? true : false}
                      onChange={(e) => setCancellationType("Provider")}
                    />
                    <Form.Label style={{ marginLeft: 12 }}>Cancelled by Provider</Form.Label>
                  </Form.Check>

                  {cancellationType !== "" ? (
                    <>
                      {cancellationType === "NoShow" ? (
                        <Form.Label style={{ marginLeft: 12 }}>To cancel please enter information relating to the Client not attending</Form.Label>
                      ) : (
                        <Form.Label style={{ marginLeft: 12 }}>To cancel please enter the reason for cancellation</Form.Label>
                      )}
                      <Form.Control
                        as="textarea"
                        rows={3}
                        name="cancellationReason"
                        value={cancellationReason}
                        onChange={(event) => setCancellationReason(event.target.value)}
                        autoComplete="new-password"
                      />
                      {cancellationType === "NoShow" ? (
                        <>
                          <Checkbox
                            aria-label="Send Cancellation SMS"
                            name="cancellationSMS"
                            value={cancellationTypeSMS}
                            onChange={(event) => updateCancellationTypeSMS(event.target.checked)}
                            style={{ paddingTop: 6, paddingLeft: 0 }}
                          />
                          <Form.Label style={{ marginLeft: 12 }}>Do you want to SMS the Client not attending</Form.Label>
                        </>
                      ) : null}
                      {cancellationTypeSMS ? (
                        <>
                          <Form.Label style={{ marginLeft: 12 }}>Please enter the SMS message</Form.Label>
                          <Form.Control
                            as="textarea"
                            rows={5}
                            name="cancellationTypeSMSText"
                            value={cancellationTypeSMSText}
                            onChange={(event) => setCancellationTypeSMSText(event.target.value)}
                            autoComplete="new-password"
                          />
                        </>
                      ) : null}
                    </>
                  ) : null}
                </Form.Group>
              </Grid>
            </Grid>
          </Modal.Body>
          <Modal.Footer className="new-booking-modal">
            <Grid container direction="row" justifyContent="space-between" alignItems="center">
              <Grid item>
                <Button variant="secondary" size="sm" onClick={() => setShowCancelProviderBooking(false)} className="lightButtonOutlinedLarge">
                  Close
                </Button>
              </Grid>
              <Grid item>
                <Button
                  variant="warning"
                  size="sm"
                  onClick={() => cancelBooking(booking.id)}
                  disabled={!cancellationReason || (cancellationReason && cancellationReason.replace(/\s/g, "").length < 5)}
                  className="lightButtonOutlinedLarge"
                >
                  Cancel Booking &gt;
                </Button>
              </Grid>
            </Grid>
          </Modal.Footer>
        </Modal>
      </FormElement>
    );
  };

  const isBooking = props.valueGetter("eventType") === undefined || props.valueGetter("eventType") === "booking";

  if (isBooking) {
    return renderBookingForm(props);
  }
};
